angular.module('tgaAdmin').controller('GameController', [
  '$rootScope',
  '$scope',
  '$state',
  '$window',
  '$timeout',
  '$location',
  '$filter',
  'gameService',
  'playerListService',
  'assetService',
  'flashService',
  'Slug',
  'fileReader',
  'domainService',
  'modalService',
  'settingsService',
  'SSOProviderService',
  'questionListService',
  '$uibModal',
  'languages',
  'userService',
  'divisionService',
  'urlService',
  '$log',
  'tzService',
  'tagService',
  '$translate',
  'translationTemplateService',
  'rootScopeCacheService',
  'placeholderDataService',
  function (
    $rootScope,
    $scope,
    $state,
    $window,
    $timeout,
    $location,
    $filter,
    gameService,
    playerListService,
    assetService,
    flashService,
    Slug,
    fileReader,
    domainService,
    modalService,
    settingsService,
    SSOProviderService,
    questionListService,
    $uibModal,
    languages,
    userService,
    divisionService,
    urlService,
    $log,
    tzService,
    tagService,
    $translate,
    translationTemplateService,
    rootScopeCacheService,
    placeholderDataService,
  ) {
    rootScopeCacheService.set('GameControllerScope', $scope);
    $scope.showBack = false;
    $scope.multipleChoiceTooltip = $filter('translate')('game.5s.multiple_choice_tooltip');
    $scope.questionTooltip = $filter('translate')('common.question_tooltip_html');
    $scope.scrambleQuestionTypesTooltip = $filter('translate')('game.scramble.question_type_tooltip_html');
    $scope.WBSQuestionTooltip = $filter('translate')('game.wbs.question_tooltip_html');
    $scope.showAIGeneration = false;
    $scope.data = {
      alerts: [],
      isOpen: [],
      gameId: $state.params.game_id || null,
      limit: 15,
      isAdmin: userService.checkUserType(['admin', 'super_admin', 'sales_admin', 'support_admin']),
      isSuperAdmin: userService.checkUserType(['super_admin']),
      allTranslations: angular.copy(languages),
      availableTranslations: angular.copy(languages),
      existingTranslations: [],
      selectedTranslation: null,
      activeTranslation: null,
      translationKeys: {
        custom_fields: {
          label: '',
        },
        custom_field_options: {
          name: '',
        },
        question: {
          answer_phrase: '',
          audio: '',
          body: '',
          column_titles: '',
          image: '',
          info_1: '',
          info_2: '',
          intro_body: '',
          intro_button: '',
          intro_title: '',
          intro_top: '',
          intro_top_2: '',
          placeholder: '',
          prestige_body: '',
          prestige_button: '',
          prestige_title: '',
          prestige_top: '',
          question_id: '',
          response_correct: '',
          response_correct_image: '',
          response_incorrect: '',
          response_incorrect_image: '',
          response_timeout: '',
          response_timeout_image: '',
          results_body: '',
          results_button: '',
          results_title: '',
          results_top: '',
          row_titles: '',
          text: '',
          video: '',
        },
        answer: {
          text: '',
          body: '',
          image: '',
          image_logo: '',
          video: '',
          video_type: '',
          response: '',
        },
        advanced_feedback: {
          image: '',
          video: '',
          video_type: '',
          audio: '',
          text: '',
        },
        question_group: {
          image: '',
          video: '',
          audio: '',
          text: '',
          name: '',
        },
      },
      hasQuestionLimit: false,
      registrationFieldArray: [],
      gameModes: [
        {
          key: 'standard',
          name: 'Single Player',
        },
        {
          key: 'instructor_initiated',
          name: 'Instructor Initiated',
        },
        {
          key: 'instructor_lead',
          name: 'Instructor Led',
        },
      ],
      questionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice',
        },
        {
          id: 'multiple_select',
          name: 'Multiple Select',
        },
        {
          id: 'image',
          name: 'Image Match',
        },
        {
          id: 'text_input',
          name: 'Text Input',
        },
        {
          id: 'poll',
          name: 'Poll',
        },
      ],
      triviaQuestionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice',
        },
        {
          id: 'multiple_select',
          name: 'Multiple Select',
        },
        {
          id: 'image',
          name: 'Image Match',
        },
        {
          id: 'text_input',
          name: 'Text Input',
        },
        {
          id: 'poll',
          name: 'Poll',
        },
        {
          id: 'interstitial',
          name: 'Info Card',
        },
      ],
      fivesQuestionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice',
        },
      ],
      scenariosQuestionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice Question',
        },
        {
          id: 'multiple_select',
          name: 'Multiple Select Question',
        },
        {
          id: 'image',
          name: 'Image Match Question',
        },
        {
          id: 'text_input',
          name: 'Text Input Question',
        },
        {
          id: 'poll',
          name: 'Poll',
        },
        {
          id: 'interstitial',
          name: 'Info Slide',
        },
      ],
      wbsQuestionTypes: [
        {
          // WBS rerranged & renamed
          id: 'image',
          name: 'Action Selection',
        },
        {
          id: 'poll',
          name: 'Scenario Option',
        },
        {
          id: 'interstitial',
          name: 'Scenario Intro/Consequence',
        },
        {
          id: 'multiple_choice',
          name: 'Something Unexpected Happens',
        },
      ],
      matchQuestionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice',
        },
        {
          id: 'multiple_select',
          name: 'Multiple Select',
        },
        {
          id: 'image',
          name: 'Image Match',
        },
        {
          id: 'text_input',
          name: 'Text Input',
        },
        {
          id: 'poll',
          name: 'Poll',
        },
      ],
      noodleQuestionTypes: [
        {
          id: 'noodle_puzzle',
          name: 'Noodle Puzzle',
        },
      ],
      scrambleQuestionTypes: [
        {
          id: 'scramble_letter',
          name: 'Letter Scramble',
        },
        {
          id: 'scramble_sentence',
          name: 'Sentence Scramble',
        },
      ],
      customFieldOptions: {
        types: [
          {
            id: 'text',
            name: 'Text Input',
          },
          {
            id: 'dropdown',
            name: 'Dropdown',
          },
        ],
        label: '',
      },
      selectedCustomFieldOption: '',
      lastQuestionType: null,
      url: urlService.composeProtocolHostPort($location),
      themes: [],
      tracks: [],
      tags: [],
      yesno: [
        {
          id: true,
          name: 'Yes',
        },
        {
          id: false,
          name: 'No',
        },
      ],
      meter_type: [
        {
          id: 'standard',
          name: 'Standard',
        },
        {
          id: 'tugofwar',
          name: 'Tug of War',
        },
      ],
      authorizationType: [
        {
          id: 0,
          name: 'No Authorization',
        },
        {
          id: 1,
          name: 'Authorized Player List',
        },
      ],
      registrationFields: {
        first_name: {
          key: 'first_name',
          label: 'First Name',
          condition: 'required',
          disabled: true,
        },
        last_name: {
          key: 'last_name',
          label: 'Last Name',
          condition: 'optional',
        },
        email: {
          key: 'email',
          label: 'Email Address',
          condition: 'required',
        },
        phone: {
          key: 'phone',
          label: 'Phone Number',
          condition: null,
        },
        employee_id: {
          key: 'employee_id',
          label: 'ID',
          condition: null,
        },
        country: {
          key: 'country',
          label: 'Country',
          condition: null,
        },
        organization: {
          key: 'organization',
          label: 'Organization',
          condition: null,
        },
      },
      registrationFieldOptions: [
        {
          id: 'required',
          name: 'Required',
        },
        {
          id: 'optional',
          name: 'Optional',
        },
        {
          id: null,
          name: 'Disabled',
        },
      ],
      registrationCustomFieldOptions: [
        {
          id: 'required',
          name: 'Required',
        },
        {
          id: 'optional',
          name: 'Optional',
        },
        {
          id: 'disabled',
          name: 'Disabled',
        },
      ],
      detectiveAnswerFieldLabels: [
        {
          header: 'Evidence (Data Types)',
          title: 'Title',
          text: 'Top Section Text',
          list: 'List',
        },
        {
          header: 'Suspects (Choices)',
          title: 'Title',
          text: 'Top Section Text',
          list: 'List',
        },
      ],
      detectiveCaseOptions: {
        types: [
          {
            id: 'intro',
            name: 'Deliberation (Match)',
          },
          {
            id: 'results',
            name: 'The Lineup (Results)',
          },
          {
            id: 'prestige',
            name: 'Final Reveal',
          },
        ],
        fields: [
          // {label: 'Title', key: '_title'},
          { label: 'Top Section', key: '_top' },
          { label: 'Body', key: '_body' },
          { label: 'Button', key: '_button' },
        ],
      },
      matchTypes: [
        {
          id: null,
          name: 'Exact',
        },
        {
          id: 'contains',
          name: 'Contains',
        },
        {
          id: 'starts_with',
          name: 'Starts With',
        },
        {
          id: 'ends_with',
          name: 'Ends With',
        },
        {
          id: 'inside',
          name: 'Inside',
        },
      ],
      playerLists: [],
      gameTypes: gameService.getGameTypes(),
      gameType: $state.params.type ? $state.params.type : null,
      gameTypeName: null,
      gameTypeDirectory: null,
      gameTypeResolution: null,
      gameTemplate: $state.params.type ? `templates/partials/game/game_${$state.params.type}.html` : null,
      splashLogoOptions: [
        {
          id: null,
          name: 'None',
        },
        {
          id: 'image',
          name: 'Upload Image',
        },
        {
          id: 'text',
          name: 'Text',
        },
      ],
      splashTitleOptions: [
        {
          id: 'default',
          name: 'Default',
        },
        {
          id: 'image',
          name: 'Upload Image',
        },
        {
          id: 'text',
          name: 'Text',
        },
        {
          id: 'none',
          name: 'None',
        },
      ],
      noodleSplashTitleOptions: [
        {
          id: 'none',
          name: 'None',
        },
        {
          id: 'text',
          name: 'Text',
        },
      ],
      splashBackgroundOptions: [
        {
          id: null,
          name: 'Default',
        },
        {
          id: 'image',
          name: 'Upload Image',
        },
      ],
      branchingOptions: [
        {
          displayText: 'Next Question',
          hash: null,
        },
      ],
      ssoProviders: [],
      questionLists: [],
      isGeneratingLTI: false,
      user: null,
      isCopy: false, // whether this is a copied game
      domains: [], // domains we can copy to
      domain: domainService.domain,
      gameSettingsWhitelist: {
        general: [],
        jeopardy: ['daily_double_1', 'daily_double_2', 'daily_double_3'],
      },
    };
    $scope.doceboUploadProcessing = false;
    $scope.showDoceboPublish = false;
    $scope.processing = false;
    $scope.getWhitelistedGameSettings = function (game) {
      // Create property list from general/game-specific keys.
      const gameSettingsWhitelist = [].concat(
        $scope.data.gameSettingsWhitelist.general,
        $scope.data.gameSettingsWhitelist[game.game_type],
      );

      // Always returns an Object.
      return _.pick(game.settings, gameSettingsWhitelist);
    };

    $scope.numeric = /^\d+$/;

    $scope.addMoreItems = function () {
      if (!$scope.loadMore && $scope.data.limit < $scope.viewmodel.game.questions.length) {
        $scope.loadMore = true;

        $timeout(() => {
          $scope.data.limit += 10;
          $scope.loadMore = false;
        }, 250);
      }
    };

    $scope.hasInterstitial = false;

    $scope.sortableOptions = {
      items: '.panel',
      containment: 'parent',
      revert: 250,
      forcePlaceholderSize: true,
      tolerance: 'pointer',
      cursor: 'move',
      handle: '.question-handle',
      placeholder: 'ui-sortable-placeholder',
      helper: 'clone',
    };

    $scope.gridRowSortableOptions = {
      items: 'tr',
      containment: '.tab-content',
      revert: 250,
      axis: 'y',
      forcePlaceholderSize: true,
      tolerance: 'pointer',
      cursor: 'move',
      handle: '.row-handle',
      placeholder: 'ui-sortable-placeholder',
      helper: 'original',
      scroll: true,
      start(e, ui) {
        ui.placeholder.height(ui.item.height());
      },
      update(e, ui) {
        // Update row titles
        const questionIndex = ui.item.sortable.source.closest('.panel').index();
        const question = $scope.viewmodel.game.questions[questionIndex];
        const from = ui.item.sortable.index;
        const to = ui.item.sortable.dropindex;
        question.row_titles.splice(to, 0, question.row_titles.splice(from, 1)[0]);
      },
    };

    $scope.answerSortableOptions = {
      items: 'tr',
      containment: '.tab-content',
      revert: 250,
      forcePlaceholderSize: true,
      tolerance: 'pointer',
      cursor: 'move',
      handle: '.answer-handle',
      placeholder: 'ui-sortable-placeholder',
      helper: 'original',
      scroll: false,
      start(e, ui) {
        ui.placeholder.height(ui.item.height());
      },
    };

    // Dynamic add for ui-select
    $scope.tagSelectItem = function (value, division) {
      const item = {
        division_id: division.division_id,
        division_option_id: null,
        value,
        label: `Add New ${division.name}`,
        labelSelected: `New ${division.name}`,
      };

      division.value = value;

      return item;
    };

    $scope.refreshSelect = function (selectObject, division) {
      if (!division.allow_add) {
        return;
      }

      if (selectObject.search) {
        if (selectObject.items.length === 0) {
          selectObject.items.push($scope.tagSelectItem(selectObject.search, division));
        } else if (selectObject.items.length === 1 && selectObject.items[0].division_option_id === null) {
          selectObject.items[0] = $scope.tagSelectItem(selectObject.search, division);
        }
      } else if (selectObject.items.length === 1 && selectObject.items[0].division_option_id === null) {
        selectObject.items = [];
      }
    };

    $scope.viewmodel = {
      game: {
        language_id: 1,
        useGlobalTimer: true,
        confetti_enabled: false,
        game_timer: null,
        useGameTimer: false,
        time_per_question: null,
        time_per_level: 60,
        privacy: false,
        questions: [],
        question_groups: [],
        question_list_id: null,
        question_list: {},
        user_list: [],
        double_jeopardy: false,
        authorization_type: 0,
        tutorial: null,
        learn_more_url: null,
        learn_more_button_text: null,
        allow_no_answer: false,
        divisions: [],
        registration: {
          required: null,
          fields: [],
          custom_fields: [],
        },
        privacy_policy_name: null,
        privacy_policy_url: null,
        privacy_policy_required: false,
        tweet_button: {
          show: false,
          tweet_text: null,
        },
        slack_button: false,
        assets: {},
        splash: {
          logo: {
            type: null,
            text: null,
            image: null,
          },
          title: {
            type: $state.params.type === 'noodle' ? 'none' : 'default',
            text: null,
            image: null,
          },
          background: {
            type: null,
            text: null,
            image: null,
          },
        },
        game_over: {
          background: {
            type: null,
            image: null,
          },
        },
        popup: {
          title: null,
          body: null,
        },
        game_type: $scope.data.gameType,
        game_mode: 'standard',
        randomize_questions: $scope.data.gameType === 'scenarios' ? false : $scope.data.gameType !== '5s',
        randomize_answers: null,
        question_limit: null,
        translations: {},
        settings: {},
        meta: null,
        metering: false,
        meter_type: null,
        question_transition: true,
        repeat_question_history: true,
        scorm_close_button: false,
        scorm_pass_fail: false,
        info_1: $scope.data.gameType === 'detective' ? 'Your Stack of Assigned Cases' : null,
        session_limit: 0,
        session_limit_start_date: null,
        session_limit_end_date: null,
        start_date: null,
        end_date: null,
        tags: [],
        original_game_id: null, // TAGT-851: Backend needs a reference to original game on save
      },
      embed: {
        width: null,
        height: null,
      },
      rawGameJSON: '',
      aiGeneration: {
        generated_questions: [],
        prompt_input: '',
        multiple_choice: 0,
        multiple_select: 0,
        random: 0,
        text_input: 0,
        loading: false,
        totalQuestionsSelected: 0,
      },
    };

    $scope.initialize = function () {
      $window.scrollTo(0, 0);
      domainService.getDomain().then((d) => {
        $scope.showDoceboPublish = d.docebo_sa_id && d.docebo_subdomain && d.docebo_client_app_id;
      });
      settingsService.getSettings().then((settings) => {
        $scope.data.settings = settings;
      });
      // Remove Instructor Initiated from Game Modes for Jeopardy
      if ($scope.data.gameType === 'jeopardy') {
        $scope.data.gameModes = [
          {
            key: 'standard',
            name: 'Single Player',
          },
          {
            key: 'instructor_lead',
            name: 'Instructor Led',
          },
        ];
      } else if ($scope.data.gameType === 'wof') {
        $scope.viewmodel.game.assets = {
          theme: 'wof',
        };
      }

      // jeopardy question setup (prevent saving empty game)
      if ($scope.isGameType(['jeopardy'])) {
        if ($scope.viewmodel.game.question_groups.length === 0) {
          // set the game up if you haven't already
          const default_num_categories = 2;
          const default_num_questions = 2;
          for (let round_index = 0; round_index < 3; round_index++) {
            const round = {
              name: ['Jeopardy!', 'Double Jeopardy!', 'Final Jeopardy!'][round_index],
              useTimer: false,
              question_group_id: null,
              question_group_type: 'multiple_choice',
              text: null,
              image: null,
              audio: null,
              video: null,
              time: 60,
              randomize_questions: true,
              num_categories: default_num_categories,
              num_questions: default_num_questions,
              question_groups: [], // Categories
              questions: [],
              max_questions: default_num_categories * default_num_questions,
              translations: {},
              isOpen: [],
            };
            $scope.viewmodel.game.question_groups.push(round);

            // add some default categories to the round
            for (let x = 0; x < default_num_categories; x++) {
              if (round_index === 2 && x > 0) {
                break; // Stop after 1 category in Final Jeopardy!
              }

              const category = {
                name: `Category ${x + 1}`,
                questions: [],
              };
              round.question_groups.push(category);

              // add some default questions to category
              for (let y = 0; y < default_num_questions; y++) {
                if (round_index === 2 && y > 0) {
                  break; // Stop after 1 question in Final Jeopardy!
                }

                const placeholder = placeholderDataService.setJeopardyPlaceholder({
                  isOpen: false,
                  question_id: null,
                  question_type: 'multiple_choice',
                  question_category: null,
                  text: null,
                  image: null,
                  audio: null,
                  video: null,
                  advanced_feedback: [],
                  points_correct: null,
                  points_incorrect: null,
                  response_correct: null,
                  response_incorrect: null,
                  response_timeout: null,
                  response_correct_image: null,
                  response_incorrect_image: null,
                  response_timeout_image: null,
                  useTimer: $scope.viewmodel.game.useGlobalTimer,
                  time: $scope.viewmodel.game.time_per_question,
                  randomize_answers: true,
                  show_results: null,
                  skip_clue: false,
                  answers: [
                    {
                      answer_id: null,
                      text: null,
                      image: null,
                      response: null,
                      correct: false,
                      points: null,
                    },
                    {
                      answer_id: null,
                      text: null,
                      image: null,
                      response: null,
                      correct: false,
                      points: null,
                    },
                  ],
                  translations: {},
                  hash: uuidv4(),
                });
                category.questions.push(placeholder);
              }
            }
          }
        }

        for (let i = 0; i < $scope.viewmodel.game.question_groups.length; i++) {
          for (let j = 0; j < $scope.viewmodel.game.question_groups[i].question_groups.length; j++) {
            const category = $scope.viewmodel.game.question_groups[i].question_groups[j];

            for (let k = 0; k < category.questions.length; k++) {
              $scope.actions.changeQuestionType(category.questions[k]);
              if (!category.questions[k].hash) {
                category.questions[k].hash = uuidv4();
              }

              if (category.questions[k].time > 0) {
                category.questions[k].useTimer = true;
              } else {
                category.questions[k].useTimer = false;
              }
            }
          }
        }
      }

      // Noodle question setup
      if ($scope.isGameType(['noodle'])) {
        if ($scope.viewmodel.game.questions.length === 0) {
          const placeholder = placeholderDataService.setNoodlePlaceholder({
            question_id: null,
            question_type: 'noodle_puzzle',
            max_answers: 4,
            max_correct: 1,
            min_answers: 2,
            next_question_hash_correct: null,
            next_question_hash_incorrect: null,
            next_question_hash_timeout: null,
            question_category: null,
            answer_phrase: null,
            body: null,
            text: null,
            image: null,
            interstitial: {
              bg_color: null,
              name: null,
              text_color: null,
              text_shadow: false,
            },
            audio: null,
            video: null,
            advanced_feedback: [],
            points_correct: null,
            points_incorrect: null,
            response_correct: null,
            response_incorrect: null,
            response_timeout: null,
            response_correct_image: null,
            response_incorrect_image: null,
            response_timeout_image: null,
            useTimer: true,
            watch_video: null,
            translations: {},
            time: null,
            randomize_answers: true,
            show_results: null,
            answers: [
              {
                answer_id: null,
                text: null,
                match_type: null,
                next_question_hash: null,
                type: null,
                image: null,
                response: null,
                correct: false,
                points: null,
              },
              {
                answer_id: null,
                text: null,
                match_type: null,
                next_question_hash: null,
                type: null,
                image: null,
                response: null,
                correct: false,
                points: null,
              },
            ],
            hash: uuidv4(),
          });

          $scope.viewmodel.game.questions.push(placeholder);
        }
      }

      if ($scope.data.gameId) {
        $scope.loading = true;
        gameService.getGame($scope.data.gameId).then(
          (game) => {
            $scope.viewmodel.rawGameJSON = angular.toJson(game);
            if (!userService.checkUserType(['super_admin']) && !domainService.hasPermission('game', game.game_type)) {
              $timeout(() => {
                modalService
                  .showModal({
                    title: 'Game Subscription Expired',
                    message: 'Upgrade your account to access this game type.',
                    closeButton: false,
                    actionButton: 'OK',
                  })
                  .then(() => {
                    $state.go('v1.account', {
                      tab: 'subscriptions',
                    });
                  });
              }, 0);
            }

            $log.log(game);

            // @TODO: use resolve to handle this
            $scope.title = `<span class="text-muted">Edit Game /</span> ${game.name}`;

            if (game.game_type === 'grid') {
              game = $scope.actions.formatGridGame(game);
            }

            game.meta = angular.isObject(game.meta) ? angular.toJson(game.meta) : game.meta;
            // Ensure `settings` is an Object with only defined general/game-specific properties.
            game.settings = $scope.getWhitelistedGameSettings(game);

            $scope.viewmodel.game = game;
            $log.debug('Game Loaded', { game, json: $scope.viewmodel.rawGameJSON });

            // Parse date to user's timezone
            if ($scope.viewmodel.game.session_limit_start_date) {
              $scope.viewmodel.game.session_limit_start_date = tzService.parseUserDate(
                $scope.viewmodel.game.session_limit_start_date,
              );
            }
            if ($scope.viewmodel.game.session_limit_end_date) {
              $scope.viewmodel.game.session_limit_end_date = tzService.parseUserDate(
                $scope.viewmodel.game.session_limit_end_date,
              );
            }
            if ($scope.viewmodel.game.start_date) {
              $scope.viewmodel.game.start_date = tzService.parseUserDate($scope.viewmodel.game.start_date);
            }
            if ($scope.viewmodel.game.end_date) {
              $scope.viewmodel.game.end_date = tzService.parseUserDate($scope.viewmodel.game.end_date);
            }

            $scope.data.gameType = game.game_type;

            // Remove Instructor Initiated from Game Modes for Jeopardy
            if ($scope.data.gameType === 'jeopardy') {
              $scope.data.gameModes = [
                {
                  key: 'standard',
                  name: 'Single Player',
                },
                {
                  key: 'instructor_lead',
                  name: 'Instructor Led',
                },
              ];
              // set the question type values on the form after initial load
              for (let i = 0; i < $scope.viewmodel.game.question_groups.length; i++) {
                for (let j = 0; j < $scope.viewmodel.game.question_groups[i].question_groups.length; j++) {
                  const category = $scope.viewmodel.game.question_groups[i].question_groups[j];

                  for (let k = 0; k < category.questions.length; k++) {
                    $scope.actions.changeQuestionType(category.questions[k]);
                    if (!category.questions[k].hash) {
                      category.questions[k].hash = uuidv4();
                    }

                    if (category.questions[k].time > 0) {
                      category.questions[k].useTimer = true;
                    } else {
                      category.questions[k].useTimer = false;
                    }
                  }
                }
              }
            }

            $scope.data.hasQuestionLimit = !!game.question_limit;

            // if game is trivia, check if there are any interstitials - hide question randomization field if so
            $scope.actions.hasInterstitials();

            const gameType =
              $filter('filter')(
                $scope.data.gameTypes,
                {
                  key: $scope.data.gameType,
                },
                true,
              )[0] || {};

            $scope.data.gameTypeName = gameType.name;
            $scope.data.gameTypeDirectory = gameType.directory;
            $scope.data.gameTypeResolution = gameType.resolution;

            $scope.data.gameTemplate = `templates/partials/game/game_${game.game_type}.html`;

            for (let i = 0; i < game.registration.fields.length; i++) {
              if (game.registration.fields[i].key === 'initials') {
                delete game.registration.fields[i];
                $scope.data.registrationFields.first_name.key = 'initials';
                $scope.data.registrationFields.first_name.label = 'Initials';
                break;
              }
            }

            $scope.viewmodel.game.registration.fields = angular.extend(
              {},
              $scope.data.registrationFields,
              _.keyBy(game.registration.fields, 'key'),
            );

            $scope.actions.checkLeaderboardFields();
            if ($scope.isGameType(['recall'])) {
              for (let i = 0; i < $scope.viewmodel.game.question_groups.length; i++) {
                if ($scope.viewmodel.game.question_groups[i].time > 0) {
                  $scope.viewmodel.game.question_groups[i].useTimer = true;
                } else {
                  $scope.viewmodel.game.question_groups[i].useTimer = false;
                }

                const question_group = $scope.viewmodel.game.question_groups[i];

                for (let j = 0; j < question_group.questions.length; j++) {
                  $scope.actions.changeQuestionType(question_group.questions[j]);
                }
              }
            } else {
              for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
                $scope.actions.changeQuestionType($scope.viewmodel.game.questions[i]);

                if ($scope.viewmodel.game.questions[i].time > 0) {
                  $scope.viewmodel.game.questions[i].useTimer = true;
                } else {
                  $scope.viewmodel.game.questions[i].useTimer = false;
                }
              }
            }

            if ($scope.viewmodel.game.time_per_question > 0) {
              $scope.viewmodel.game.useGlobalTimer = true;
            } else {
              $scope.viewmodel.game.useGlobalTimer = false;
            }

            if ($scope.viewmodel.game.game_timer > 0) {
              $scope.viewmodel.game.useGameTimer = true;
            } else {
              $scope.viewmodel.game.useGameTimer = false;
            }

            assetService.getThemes($scope.viewmodel.game.game_type).then((themes) => {
              $scope.data.themes = themes;
              $scope.actions.updateTheme();
            });

            $log.log($scope.viewmodel.game);

            $scope.actions.filterLanguages(game);
            $scope.actions.updateBranchOptions();
            $scope.loading = false;
          },
          () => {
            // Invalid Game ID
            $state.go('v1.games');
          },
        );
      } else {
        if (!$state.params.type || !domainService.hasPermission('game', $state.params.type)) {
          // Timeout hack so modal backdrop always shows
          $timeout(() => {
            modalService
              .showModal({
                title: 'Upgrade Required',
                message: 'Upgrade your account to access this game type.',
                closeButton: false,
                actionButton: 'OK',
              })
              .then(() => {
                $state.go('v1.games');
              });
          }, 0);

          return;
        }

        const gameType =
          $filter('filter')(
            $scope.data.gameTypes,
            {
              key: $scope.data.gameType,
            },
            true,
          )[0] || {};

        $scope.data.gameTypeName = gameType.name;
        $scope.data.gameTypeDirectory = gameType.directory;

        $scope.title = `<span class="text-muted">New Game /</span> <span class="text-capitalize">${$scope.data.gameTypeName}</span>`;

        delete $scope.data.availableTranslations[1];

        assetService.getThemes($scope.viewmodel.game.game_type).then((themes) => {
          $scope.data.themes = themes;
          $scope.viewmodel.game.assets.theme = themes[0].key;
          // Don't let new Noodle™ game default to custom
          if ($scope.viewmodel.game.game_type === 'noodle' && $scope.viewmodel.game.assets.theme === 'custom') {
            $scope.viewmodel.game.assets.theme = 'noodle_theme';
          }
          $scope.actions.updateTheme();
        });

        divisionService.getDivisions().then((divisions) => {
          $scope.viewmodel.game.divisions = divisions;
        });

        // games shouldnt be pre-marked as isCopy. make sure that was reset.
        if ($scope.data.isCopy) {
          $log.error('game started off as a copy, which is an error.');
        }

        // if the game is a copy
        if ($state.params.viewmodel && $state.params.data) {
          $scope.viewmodel = $state.params.viewmodel;
          $scope.data = $state.params.data;
          // if the copied game is a demo game, set the copied game to not be a demo
          $scope.viewmodel.game.is_demo = false;
        }
      }

      playerListService.getPlayerLists().then((playerLists) => {
        $scope.data.playerLists = [];
        playerLists.forEach((playerList) => {
          $scope.data.playerLists.push({
            player_list_id: playerList.player_list_id,
            name: playerList.name,
          });
        });
      });

      settingsService.getSettings().then((settings) => {
        $scope.data.settings = settings;
        if (settings.display_sso === 'true') {
          $scope.data.authorizationType = [
            {
              id: 0,
              name: 'No Authorization',
            },
            {
              id: 1,
              name: 'Authorized Player List',
            },
            {
              id: 2,
              name: 'Single Sign-On',
            },
          ];
        }
      });

      SSOProviderService.getSSOProviders().then((ssoProviders) => {
        $scope.data.ssoProviders = ssoProviders;
      });

      questionListService.getQuestionLists().then((questionLists) => {
        $scope.data.questionLists = questionLists;
      });

      tagService.getTags().then((tags) => {
        $scope.data.tags = tags;
      });

      // get domains for Copy Game Subdomain modal
      if ($state.params.viewmodel && $state.params.data) {
        $scope.data.isCopy = true;
        domainService.getUserDomainsHavingGameType($scope.data.gameType).then((domains) => {
          if (domains) {
            for (let i = 0; i < domains.length; i++) {
              $scope.data.domains.push({
                name: `${domains[i].name}.${domainService.base}${
                  domains[i].name === $scope.data.domain ? ' (current)' : ''
                }`,
                value: domains[i].name,
                copyable: !!domains[i].copyable,
              });
            }
          }
        });
      }
    };

    $scope.actions = {
      submit(showAlert) {
        $scope.processing = true;

        $log.log('saving viewmodel', $scope.viewmodel.game);

        const gameData = _.cloneDeep($scope.viewmodel.game); // Using underscore because angular.copy destroys File objects

        // Date gets set to `true` when you clear the field
        if (gameData.session_limit_start_date === true) {
          gameData.session_limit_start_date = null;
        }
        if (gameData.session_limit_end_date === true) {
          gameData.session_limit_end_date = null;
        }
        if (gameData.start_date === true) {
          gameData.start_date = null;
        }
        if (gameData.end_date === true) {
          gameData.end_date = null;
        }

        // Convert date back to UTC for storing in the database
        if (gameData.session_limit_start_date) {
          gameData.session_limit_start_date = gameData.session_limit_start_date.utc().format();
        }
        if (gameData.session_limit_end_date) {
          gameData.session_limit_end_date = gameData.session_limit_end_date.utc().format();
        }
        if (gameData.start_date) {
          gameData.start_date = gameData.start_date.utc().format();
        }
        if (gameData.end_date) {
          gameData.end_date = gameData.end_date.utc().format();
        }

        // Flatten grid answer rows
        if (gameData.game_type === 'grid') {
          const { questions } = gameData;
          for (let i = 0; i < questions.length; i++) {
            const question = questions[i];
            // eslint-disable-next-line prefer-spread
            const flattenedAnswers = [].concat.apply([], question.answers);
            question.answers = flattenedAnswers;
          }
        }

        if (!gameData.registration.required && gameData.registration.custom_fields.length) {
          gameData.registration.custom_fields.forEach((cf) => {
            cf.condition = 'disabled';
          });
        }

        // If the user has added an empty translation, add an empty array to the question/question_group translations
        $scope.data.existingTranslations.forEach((lang) => {
          if (gameData.questions.length) {
            gameData.questions.forEach((question) => {
              if (!question.translations[lang.language_id]) {
                question.translations[lang.language_id] = [];
              }
            })
          }

          if (gameData.question_groups.length) {
            gameData.question_groups.forEach((q_group) => {
              if (!q_group.translations[lang.language_id]) {
                q_group.translations[lang.language_id] = [];
              }
              // jeopardy-specific
              if ($scope.isGameType(['jeopardy'])) {
                q_group.question_groups.forEach((q_group_q_group) => {
                  if (!q_group_q_group.translations[lang.language_id]) {
                    q_group_q_group.translations[lang.language_id] = [];
                  }
                  q_group_q_group.questions.forEach((qg_question) => {
                    if (!qg_question.translations[lang.language_id]) {
                      qg_question.translations[lang.language_id] = [];
                    }
                  })
                })
              }
            })
          }
        })

        // [TAGT-851] Copy game to subdomain: display a modal on save that prompts the user to select domain destination.
        if (($state.params.viewmodel && $state.params.data) || $scope.data.isCopy) {

          // If there is only one domain this user can access, then skip this part entirely.
          if ($scope.data.domains.length > 1) {
            // Open Game Copy Subdomain modal to prompt the user to select the domain
            // eslint-disable-next-line consistent-return
            return $uibModal
              .open({
                animation: true,
                templateUrl: 'templates/partials/modal-game-copy-subdomain.html',
                controller: 'GameCopySubdomainModalController',
                backdrop: true,
                size: 'lg',
                resolve: {
                  extras() {
                    return {
                      closeButton: true,
                      domains: angular.copy($scope.data.domains),
                      domain: angular.copy($scope.data.domain),
                      usesQuestionList: gameData.question_list_id !== null,
                    };
                  },
                },
              })
              .result.then((destination) => {
                gameData.domain = destination;
                // After the user chooses a domain, continue adding new game.
                // eslint-disable-next-line consistent-return
                return gameService
                  .addGame(gameData)
                  .then((game) => {
                    flashService.set('<span class="fa fa-check"></span> Game copied successfully.', 'success');
                    $scope.processing = false;
                    $scope.gameForm.$setPristine();

                    // If the destination is different than the current domain.
                    if (destination !== $scope.data.domain) {
                      const domain = `${destination}.${domainService.base}`;
                      const link = `<a href="https://${domain}/admin/v1/login">${domain}</a>`;
                      const originalDomain = `${$scope.data.domain}.${domainService.base}`;
                      const originalGameID = $scope.viewmodel.game.original_game_id;
                      const originalGame = `<a href="https://${originalDomain}/admin/v1/game/${originalGameID}">${originalDomain}</a>`;
                      modalService
                        .showModal(
                          {
                            title: 'Switch Domain?',
                            // eslint-disable-next-line max-len
                            message: `<strong>Step 4:</strong><br>To edit the original game, click here:<br> ${originalGame}<br>To edit the transferred game, click here:<br> ${link}`,
                            closeButton: 'Cancel',
                          },
                          {
                            backdrop: true,
                            keyboard: true,
                            animation: false,
                          },
                        )
                        .then(
                          () => {
                            $state.go('v1.games', {
                              game_id: game.game_id,
                            });
                          },
                          () => {},
                        );
                    } else {
                      $state.go('v1.editGame', {
                        game_id: game.game_id,
                      });
                    }
                  })
                  .catch((error) => {
                    if (error.message) {
                      $scope.actions.createAlert(
                        `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                        'danger',
                      );
                    } else {
                      $scope.actions.createAlert(
                        '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ' +
                          'There was an error processing your request.',
                        'danger',
                      );
                    }

                    if (error.fields) {
                      for (let i = 0; i < error.fields.length; i++) {
                        if ($scope.gameForm[error.fields[i]]) {
                          $scope.gameForm[error.fields[i]].$setValidity('required', false);
                        }
                      }
                    }

                    $scope.processing = false;
                  });
              })
              .catch(() => {
                $scope.processing = false;
              });
          }
        }

        if ($scope.data.gameId) {
          // Editing game
          // eslint-disable-next-line consistent-return
          return gameService
            .updateGame(gameData)
            .then((game) => {
              $timeout(() => {
                $scope.actions.processGame(game, showAlert);
                $scope.viewmodel.rawGameJSON = angular.toJson(game);
                $scope.gameForm.$setPristine();
                $log.debug('Game Updated', { game, json: $scope.viewmodel.rawGameJSON });

                // saving a translation that is empty will remove it from the availableTranslations
                // and while also not being saved in existingTranslations
                // read missing keys back into availableTranslations
                $scope.data.availableTranslations = _.cloneDeep($scope.data.allTranslations);
                $scope.data.existingTranslations.forEach((lang) => {
                  delete $scope.data.availableTranslations[lang.language_id];
                });
                delete $scope.data.availableTranslations[$scope.viewmodel.game.language_id];
                if ($scope.data.existingTranslations.length > 0) {
                  [$scope.data.activeTranslation] = $scope.data.existingTranslations;
                } else {
                  $scope.data.activeTranslation = null;
                }
              }, 2000);
            })
            .catch((error) => {
              if (error.message) {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
              } else {
                $scope.actions.createAlert(
                  '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> There was an error processing your request.',
                  'danger',
                );
              }

              if (error.fields) {
                for (let i = 0; i < error.fields.length; i++) {
                  if ($scope.gameForm[error.fields[i]]) {
                    $scope.gameForm[error.fields[i]].$setValidity('required', false);
                  }
                }
              }

              $scope.processing = false;
            });
        }
        // Adding new game
        // eslint-disable-next-line consistent-return
        return gameService
          .addGame(gameData)
          .then((game) => {
            flashService.set('<span class="fa fa-check"></span> Game added successfully.', 'success');
            $scope.processing = false;
            $scope.gameForm.$setPristine();
            $state.go('v1.editGame', {
              game_id: game.game_id,
            });
          })
          .catch((error) => {
            if (error.message) {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
            } else {
              $scope.actions.createAlert(
                '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> There was an error processing your request.',
                'danger',
              );
            }

            if (error.fields) {
              for (let i = 0; i < error.fields.length; i++) {
                if ($scope.gameForm[error.fields[i]]) {
                  $scope.gameForm[error.fields[i]].$setValidity('required', false);
                }
              }
            }

            $scope.processing = false;
          });
      },
      checkGameForm() {
        $scope.submitted = true;

        // [TAGT-1527] check if popup body has content
        if ($scope.viewmodel.game.popup.body !== null) {
          // parse body string
          const popup_body = $scope.viewmodel.game.popup.body.split(/<\/p>|<br>|<p>|>/);

          let popup_body_has_content = false;
          for (let i = 0; i < popup_body.length; i++) {
            // remove spaces
            popup_body[i] = popup_body[i].replace(/ /g, '');
            // check for non empty strings and non paragraph tags.
            // other tags like span and list can continue (span requires text)
            if (popup_body[i] !== '' && popup_body[i].substring(0, 2) !== '<p') {
              popup_body_has_content = true;
              break;
            }
          }
          if (!popup_body_has_content) {
            $scope.viewmodel.game.popup.body = null;
          }
        }

        // prepend http to privacy policy url if it doesnt have it
        if ($scope.viewmodel.game.privacy_policy_url) {
          const urlPattern = /^((http|https):\/\/)/;
          if (!urlPattern.test($scope.viewmodel.game.privacy_policy_url)) {
            $scope.viewmodel.game.privacy_policy_url = `http://${$scope.viewmodel.game.privacy_policy_url}`;
          }
        }

        if ($scope.timer) {
          $timeout.cancel($scope.timer);
        }

        $('.tabs-fixed > .nav-tabs > .uib-tab').removeClass('has-error');

        for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
          $scope.viewmodel.game.questions[i].has_error = false;
        }

        if ($scope.isGameType(['noodle'])) {
          for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
            const currentQuestion = $scope.viewmodel.game.questions[i];
            currentQuestion.answers[0].text = currentQuestion.answer_phrase;
          }
        }

        if ($scope.isGameType(['jeopardy'])) {
          for (let i = 0; i < $scope.viewmodel.game.question_groups.length; i++) {
            for (let j = 0; j < $scope.viewmodel.game.question_groups[i].question_groups.length; j++) {
              const category = $scope.viewmodel.game.question_groups[i].question_groups[j];
              category.has_error = false;

              for (let k = 0; k < category.questions.length; k++) {
                category.questions[k].has_error = false;
                if (category.questions[k].advanced_feedback) {
                  for (let n = 0; n < category.questions[k].advanced_feedback.length; n++) {
                    const af = category.questions[k].advanced_feedback[n];
                    af.has_error = false;
                    if (af.text == null && af.video.type == null && af.video.url == null) {
                      if (af.image == null) {
                        af.has_error = true;
                      } else if (af.image.original == null && af.image.filetype == null) {
                        af.has_error = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        if ($scope.isGameType(['trivia'])) {
          for (let k = 0; k < $scope.viewmodel.game.questions.length; k++) {
            $scope.viewmodel.game.questions[k].has_error = false;
            if ($scope.viewmodel.game.questions[k].advanced_feedback) {
              for (let n = 0; n < $scope.viewmodel.game.questions[k].advanced_feedback.length; n++) {
                const af = $scope.viewmodel.game.questions[k].advanced_feedback[n];
                af.has_error = false;
                if (af.text == null && af.video.type == null && af.video.url == null) {
                  if (af.image == null) {
                    af.has_error = true;
                  } else if (af.image.original == null && af.image.filetype == null) {
                    af.has_error = true;
                  }
                }
              }
            }
          }
        }

        for (let i = 0; i < $scope.data.existingTranslations.length; i++) {
          $scope.data.existingTranslations[i].has_error = false;
        }

        let hasError = false;
        let errorString = '';
        let skipErrorStringAssignment = false;

        // prevent saving without any questions for most games
        if (
          (!$scope.isGameType(['flash', 'detective', 'jeopardy', 'recall']) &&
            !$scope.viewmodel.game.questions.length) ||
          ($scope.isGameType(['recall']) &&
            (!$scope.viewmodel.game.question_groups.length ||
              !$scope.viewmodel.game.question_groups.every((x) => x.questions.length))) ||
          ($scope.isGameType(['detective']) &&
            (!$scope.viewmodel.game.questions.length ||
              !$scope.viewmodel.game.questions.every((x) => x.answers.every((y) => y.answers.length)))) ||
          ($scope.isGameType(['jeopardy']) &&
            (!$scope.viewmodel.game.question_groups.length ||
              !$scope.viewmodel.game.question_groups.every((x) => x.question_groups.every((y) => y.questions.length))))
        ) {
          hasError = true;
          // show red dot in tab
          $('.tabs-fixed > .nav-tabs > .uib-tab').eq(1).addClass('has-error');
        } else if ($scope.isGameType(['detective'])) {
          // if game has passed the cursory checks do futher advanced checks here
          // currently just checking detective has at least one guilty suspect
          const { questions } = $scope.viewmodel.game;
          let caseHasAGuiltySuspect = false;
          for (let i = 0; i < questions.length; i++) {
            const detectiveCase = questions[i];
            const suspects = detectiveCase.answers[1].answers;
            for (let j = 0; j < suspects.length; j++) {
              if (suspects[j].correct) {
                caseHasAGuiltySuspect = true;
              }
            }
          }
          hasError = !caseHasAGuiltySuspect;
          if (hasError) {
            skipErrorStringAssignment = true;
            errorString = $translate.instant('common.check_form_for_detective_one_guilty').toString();
          }
        }

        if ($scope.isGameType(['scenarios'])) {
          const { questions } = $scope.viewmodel.game;

          for (let i = 0; i < questions.length; i++) {
            const question = questions[i];
            question.layout_required = false;

            if (!question.layout) {
              question.has_error = true;
              question.layout_required = true;
              hasError = true;
            }
          }
        }

        if ($scope.gameForm.$invalid || hasError) {
          if (!skipErrorStringAssignment) {
            errorString = $translate.instant('common.check_form_for_questions').toString();
            if ($scope.gameForm.$invalid) {
              errorString = $translate.instant('common.check_form_for_errors').toString();
            } else if ($scope.isGameType(['recall'])) {
              if (!$scope.viewmodel.game.question_groups.length) {
                errorString = $translate.instant('common.check_form_for_question_groups').toString();
              } else {
                errorString = $translate.instant('common.check_form_for_questions').toString();
              }
            } else if ($scope.isGameType(['detective'])) {
              if (!$scope.viewmodel.game.questions.every((x) => x.answers.every((y) => y.answers.length))) {
                errorString = $translate.instant('common.check_form_for_detective_evidence_or_suspect').toString();
              } else {
                errorString = $translate.instant('common.check_form_for_detective_cases').toString();
              }
            }
          }

          $scope.actions.createAlert(`<span class="fa fa-exclamation-triangle"></span> ${errorString}`, 'danger');

          const field = $(':input.ng-invalid:visible:first');

          if (field.length) {
            $('html, body')
              .stop(true, false)
              .animate(
                {
                  scrollTop: field.parent().offset().top - 110,
                },
                450,
              );
          }

          $('.tabs-fixed > .tab-content > .tab-pane').each(function (i) {
            if ($(this).find('.ng-invalid').length) {
              $('.tabs-fixed > .nav-tabs > .uib-tab').eq(i).addClass('has-error');
            }
          });

          $('.translation').each(function (i) {
            if ($(this).find('.ng-invalid').length) {
              $scope.data.existingTranslations[i].has_error = true;
            }
          });

          if ($scope.viewmodel.game.questions.length && !$scope.isGameType(['trivia'])) {
            $('.panel-group .panel').each(function (i) {
              if ($(this).find('.ng-invalid').length) {
                $scope.viewmodel.game.questions[i].has_error = true;
              }
            });
          }

          if ($scope.isGameType(['trivia'])) {
            if ($scope.viewmodel.game.questions.length) {
              $('.panel-primary').each(function (i) {
                if ($(this).find('.ng-invalid').length) {
                  $scope.viewmodel.game.questions[i].has_error = true;
                }
              });
            }
          }

          if ($scope.isGameType(['jeopardy'])) {
            $('#parent-group > .panel').each(function (i) {
              $('.category-group', this).each(function (j) {
                $(this)
                  .children('.panel-group')
                  .children('.panel')
                  .each(function (k) {
                    if ($(this).find('.ng-invalid').length) {
                      $scope.viewmodel.game.question_groups[i].question_groups[j].has_error = true;
                      $scope.viewmodel.game.question_groups[i].question_groups[j].questions[k].has_error = true;
                    }
                  });
              });
            });
          }

          if (!field.length) {
            const panel = $('.panel-group .panel-danger:visible:first');

            if (panel.length) {
              $('html, body')
                .stop(true, false)
                .animate(
                  {
                    scrollTop: panel.offset().top - 120,
                  },
                  450,
                );
            }
          }
        } else {
          if ($scope.viewmodel.game.is_demo) {
            $scope.actions.toggleDemoModal();
          } else if (
            $scope.generatedAITranslation ||
            $scope.viewmodel.game.questions.some((question) => question.generated_question && !question.verified)
          ) {
            $scope.actions.toggleAIConfirmModal();
          } else {
            $scope.actions.submit(true);
          }
        }
      },
      copyGame() {
        modalService
          .showModal(
            {
              title: 'Copy Game?',
              message:
                // eslint-disable-next-line max-len
                '<strong>Step 1:</strong> Click "Copy Game".  <strong>Important reminder</strong>:  please save the game you are currently editing before copying.',
              closeButton: 'Cancel',
              actionButton: 'Copy Game',
              actionClass: 'primary',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              // reset the game ID
              $scope.data.gameId = null;
              // get rid of keys that get added when you create a game
              // Preserve the old game_id for the backend to reference when
              $scope.viewmodel.game.original_game_id = $scope.viewmodel.game.game_id;
              delete $scope.viewmodel.game.game_id;
              delete $scope.viewmodel.game.ext_game_id;
              delete $scope.viewmodel.game.date_created;
              // rename the game and slug
              $scope.viewmodel.game.name = `${$scope.viewmodel.game.name} copy`;
              $scope.viewmodel.game.slug = `${$scope.viewmodel.game.slug}-copy`;
              flashService.set('<span class="fa fa-check"></span> Please click "Save".', 'warning');
              // go to add game page and pass in viewmodel and data copies
              $state.go('v1.addGame', {
                type: $scope.viewmodel.game.game_type,
                viewmodel: $scope.viewmodel,
                data: $scope.data,
              });
            },
            () => {},
          );
      },
      saveGame() {
        if ($scope.isGameType(['recall'])) {
          $scope.actions.verifyQuestionGroups();
        } else if ($scope.isGameType(['wof'])) {
          $scope.actions.wofPreprocessAndSubmit();
        } else {
          $scope.actions.checkGameForm();
        }
      },
      hasInterstitials() {
        $timeout(() => {
          if ($scope.isGameType(['trivia', 'grid'])) {
            for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
              if ($scope.viewmodel.game.questions[i].question_type === 'interstitial') {
                // hides the randomize question field
                $scope.hasInterstitial = true;
                if ($scope.viewmodel.game.randomize_questions) {
                  $scope.actions.createAlert(
                    '<span class="fa fa-exclamation-triangle"></span> Question randomization removed.',
                    'danger',
                  );
                  $scope.viewmodel.game.randomize_questions = false;
                  $scope.viewmodel.game.question_limit = null;
                }
                return;
              }
            }
            // if no interstitials - show the randomize question field
            $scope.hasInterstitial = false;
          }
        });
      },
      processGame(game, successAlert) {
        if (successAlert) {
          $scope.actions.createAlert('<span class="fa fa-check"></span> Game updated successfully.', 'success');
        }

        if (game.game_type === 'grid') {
          game = $scope.actions.formatGridGame(game);
        }

        $scope.processing = false;
        $scope.title = `<span class="text-muted">Edit Game /</span> ${game.name}`;
        game.meta = angular.isObject(game.meta) ? angular.toJson(game.meta) : game.meta;
        // Ensure `settings` is an Object with only defined general/game-specific properties.
        game.settings = $scope.getWhitelistedGameSettings(game);
        $scope.viewmodel.game = game;

        $log.log('processGame setting game in viewmodel: ', game);

        for (let i = 0; i < game.registration.fields.length; i++) {
          if (game.registration.fields[i].key === 'initials') {
            delete game.registration.fields[i];
            $scope.data.registrationFields.first_name.key = 'initials';
            $scope.data.registrationFields.first_name.label = 'Initials';
            break;
          }
        }

        $scope.viewmodel.game.registration.fields = angular.extend(
          {},
          $scope.data.registrationFields,
          _.keyBy(game.registration.fields, 'key'),
        );

        for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
          const question = $scope.viewmodel.game.questions[i];
          $scope.actions.changeQuestionType(question);
        }

        if ($scope.viewmodel.game.time_per_question > 0) {
          $scope.viewmodel.game.useGlobalTimer = true;
        } else {
          $scope.viewmodel.game.useGlobalTimer = false;
        }

        if ($scope.viewmodel.game.game_timer > 0) {
          $scope.viewmodel.game.useGameTimer = true;
        } else {
          $scope.viewmodel.game.useGameTimer = false;
        }

        if ($scope.isGameType(['jeopardy'])) {
          for (let i = 0; i < $scope.viewmodel.game.question_groups.length; i++) {
            for (let j = 0; j < $scope.viewmodel.game.question_groups[i].question_groups.length; j++) {
              const category = $scope.viewmodel.game.question_groups[i].question_groups[j];

              for (let k = 0; k < category.questions.length; k++) {
                $scope.actions.changeQuestionType(category.questions[k]);

                if (!category.questions[k].hash) {
                  category.questions[k].hash = uuidv4();
                }

                if (category.questions[k].time > 0) {
                  category.questions[k].useTimer = true;
                } else {
                  category.questions[k].useTimer = false;
                }
              }
            }
          }
        } else if ($scope.isGameType(['recall'])) {
          for (let i = 0; i < $scope.viewmodel.game.question_groups.length; i++) {
            if ($scope.viewmodel.game.question_groups[i].time > 0) {
              $scope.viewmodel.game.question_groups[i].useTimer = true;
            } else {
              $scope.viewmodel.game.question_groups[i].useTimer = false;
            }

            const question_group = $scope.viewmodel.game.question_groups[i];

            for (let j = 0; j < question_group.questions.length; j++) {
              $scope.actions.changeQuestionType(question_group.questions[j]);
            }
          }
        } else {
          for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
            if ($scope.viewmodel.game.questions[i].time > 0) {
              $scope.viewmodel.game.questions[i].useTimer = true;
            } else {
              $scope.viewmodel.game.questions[i].useTimer = false;
            }
          }
        }

        // Parse date to user's timezone
        if ($scope.viewmodel.game.session_limit_start_date) {
          $scope.viewmodel.game.session_limit_start_date = tzService.parseUserDate(
            $scope.viewmodel.game.session_limit_start_date,
          );
        }
        if ($scope.viewmodel.game.session_limit_end_date) {
          $scope.viewmodel.game.session_limit_end_date = tzService.parseUserDate(
            $scope.viewmodel.game.session_limit_end_date,
          );
        }
        if ($scope.viewmodel.game.start_date) {
          $scope.viewmodel.game.start_date = tzService.parseUserDate($scope.viewmodel.game.start_date);
        }
        if ($scope.viewmodel.game.end_date) {
          $scope.viewmodel.game.end_date = tzService.parseUserDate($scope.viewmodel.game.end_date);
        }

        $scope.actions.updateBranchOptions();
        $scope.actions.updateTheme();
        $scope.actions.filterLanguages(game);

        $scope.submitted = false;
      },
      filterLanguages(game) {
        // filter the available languages
        $scope.data.existingTranslations = [];
        for (let i = 0; i < $scope.viewmodel.game.available_translations.length; i++) {
          delete $scope.data.availableTranslations[$scope.viewmodel.game.available_translations[i].language_id];

          if ($scope.viewmodel.game.available_translations[i].language_id !== game.language_id) {
            $scope.data.existingTranslations.push($scope.viewmodel.game.available_translations[i]);
          }
        }

        [$scope.data.activeTranslation] = $scope.data.existingTranslations;
      },
      addQuestion(qType) {
        if ($scope.isGameType(['grid']) && qType !== 'interstitial') {
          $scope.actions.addGridQuestion();
          return;
        }

        if ($scope.isGameType(['detective'])) {
          $scope.actions.addDetectiveQuestion();
          return;
        }

        $scope.gameForm.$setDirty();
        $scope.data.limit = 500;

        const { lastQuestionType } = $scope.data;
        let questionType;

        if (qType === 'interstitial') {
          questionType = 'interstitial';
        } else if (qType === 'text_input') {
          questionType = 'text_input';
        } else if (lastQuestionType === 'interstitial') {
          questionType = 'multiple_choice';
        } else if (lastQuestionType) {
          questionType = lastQuestionType;
        } else if ($scope.isGameType(['noodle'])) {
          questionType = 'noodle_puzzle';
        } else {
          questionType = $scope.isGameType(['scramble']) ? 'scramble_letter' : 'multiple_choice';
        }

        let answers = [];

        if (qType !== 'interstitial') {
          answers = [
            {
              answer_id: null,
              type: null,
              match_type: null,
              text: null,
              image: null,
              response: null,
              correct: false,
              points: null,
              next_question_hash: null,
            },
            {
              answer_id: null,
              type: null,
              match_type: null,
              text: null,
              image: null,
              response: null,
              correct: false,
              points: null,
              next_question_hash: null,
            },
          ];
        }

        const question = {
          question_id: null,
          question_type: questionType,
          question_group: null,
          text: null,
          image: null,
          audio: null,
          video: null,
          watch_video: null,
          advanced_feedback: [],
          response_correct: null,
          response_incorrect: null,
          response_timeout: null,
          response_correct_image: null,
          response_incorrect_image: null,
          response_timeout_image: null,
          show_results: null,
          useTimer: $scope.viewmodel.game.useGlobalTimer,
          time: $scope.viewmodel.game.time_per_question,
          randomize_answers: true,
          interstitial: {
            name: null,
            text_color: questionType === 'interstitial' ? '#000000' : null,
            text_shadow: false,
            bg_color: questionType === 'interstitial' ? '#F2F5F9' : null,
          },
          answers,
          translations: {},
          hash: null,
          next_question_hash_correct: null,
          next_question_hash_incorrect: null,
          next_question_hash_timeout: null,
          points_correct: null,
          points_incorrect: null,
          generated_question: false,
          verified: false,
        };
        $scope.actions.changeQuestionType(question);
        $scope.viewmodel.game.questions.push(question);
        $scope.actions.toggleCollapse($scope.viewmodel.game.questions.length - 1);
        $scope.actions.updateBranchOptions();
      },
      addGridQuestion() {
        $scope.gameForm.$setDirty();
        $scope.data.limit = 500;

        const question = {
          question_id: null,
          question_type: 'grid',
          question_group: null,
          text: null,
          body: null,
          image: null,
          audio: null,
          video: null,
          watch_video: null,
          response_correct: null,
          response_incorrect: null,
          response_timeout: null,
          response_correct_image: null,
          response_incorrect_image: null,
          response_timeout_image: null,
          show_results: null,
          useTimer: $scope.viewmodel.game.useGlobalTimer,
          time: $scope.viewmodel.game.time_per_question,
          randomize_answers: true,
          generated_question: false,
          verified: false,
          translations: {},
          interstitial: {
            name: null,
            text_color: null,
            text_shadow: false,
            bg_color: null,
          },
          answers: [
            [
              {
                answer_id: null,
                type: null,
                text: null,
                image: null,
                response: null,
                correct: false,
                row: 0,
                col: 0,
                points: null,
              },
              {
                answer_id: null,
                type: null,
                text: null,
                image: null,
                response: null,
                correct: false,
                row: 0,
                col: 1,
                points: null,
              },
              {
                answer_id: null,
                type: null,
                text: null,
                image: null,
                response: null,
                correct: false,
                row: 0,
                col: 2,
                points: null,
              },
            ],
          ],
          column_titles: [
            {
              text: '',
              index: 0,
            },
            {
              text: '',
              index: 1,
            },
            {
              text: '',
              index: 2,
            },
          ],
          row_titles: [
            {
              text: '',
              index: 0,
            },
          ],
        };

        $scope.actions.changeQuestionType(question);
        $scope.viewmodel.game.questions.push(question);
        $scope.actions.toggleCollapse($scope.viewmodel.game.questions.length - 1);
      },
      addDetectiveQuestion() {
        $scope.gameForm.$setDirty();
        $scope.data.limit = 500;

        const question = {
          question_id: null,
          question_type: 'detective',
          question_group: null,
          text: null,
          info_1: 'Case name required',
          body: 'Case details required',
          image: null,
          audio: null,
          video: null,
          watch_video: null,
          response_correct: null,
          response_incorrect: null,
          response_correct_image: null,
          response_incorrect_image: null,
          show_results: null,
          randomize_answers: true,
          intro_title: null,
          intro_top: 'Link The Suspects To The Evidence',
          intro_top_2: 'Which Suspect Can Be Linked With Each Evidence?',
          intro_body:
            // eslint-disable-next-line max-len
            "Having done your research, it's time to decide which Suspect(s) can be linked to each piece of Evidence. You can still open and review the details of each item, but you can no longer review the case as a whole. Your associations are final, and the accuracy of your decisions impacts your final score, so deliberate carefully.",
          intro_button: null,
          results_title: null,
          results_top: 'Choose Your Final Suspect(s) From The Line Up',
          results_body:
            // eslint-disable-next-line max-len
            'The bars below show how you linked the Evidence to each Suspect. Now choose the final Suspect(s)! (Hint: Open the color key to look back at the Evidence details).',
          results_button: null,
          prestige_title: null,
          prestige_top: 'The Wrap-Up',
          prestige_body: 'Wrap-up description text required.',
          interstitial: {
            name: null,
            text_color: null,
            text_shadow: false,
            bg_color: null,
          },
          answers: [
            {
              answer_id: null,
              type: 'default',
              text: null,
              body: 'Investigate The Details For Each Piece Of Evidence',
              image: null,
              response: null,
              correct: false,
              require: true,
              row: 0,
              col: 0,
              points: null,
              answers: [],
            },
            {
              answer_id: null,
              type: 'default',
              text: null,
              body: 'Deliberate The List of Potential Suspects',
              image: null,
              response: null,
              correct: false,
              require: true,
              row: 0,
              col: 1,
              points: null,
              answers: [],
            },
          ],
          column_titles: [
            {
              text: '',
              index: 0,
            },
            {
              text: '',
              index: 1,
            },
            {
              text: '',
              index: 2,
            },
          ],
          row_titles: [
            {
              text: '',
              index: 0,
            },
          ],
        };

        $scope.actions.changeQuestionType(question);
        $scope.viewmodel.game.questions.push(question);
        $scope.actions.toggleCollapse($scope.viewmodel.game.questions.length - 1);
      },
      addGeneratedQuestions(generated) {
        $scope.gameForm.$setDirty();
        $scope.data.limit = 500;

        // For questions
        for (let genQuestion of generated) {
          let questionType = genQuestion.question_type;
          let answers = [];
          // For answers
          for (let genAnswer of genQuestion.answers) {
            answers.push({
              answer_id: null,
              type: null,
              match_type: null,
              text: genAnswer.text,
              image: null,
              response: null,
              correct: genAnswer.correct,
              points: null,
              next_question_hash: null,
            });
          }

          const question = {
            question_id: null,
            question_type: questionType,
            question_group: null,
            text: genQuestion.question,
            image: null,
            audio: null,
            video: null,
            watch_video: null,
            advanced_feedback: [],
            response_correct: null,
            response_incorrect: null,
            response_timeout: null,
            response_correct_image: null,
            response_incorrect_image: null,
            response_timeout_image: null,
            show_results: null,
            useTimer: $scope.viewmodel.game.useGlobalTimer,
            time: $scope.viewmodel.game.time_per_question,
            randomize_answers: true,
            interstitial: {
              name: null,
              text_color: questionType === 'interstitial' ? '#000000' : null,
              text_shadow: false,
              bg_color: questionType === 'interstitial' ? '#F2F5F9' : null,
            },
            answers,
            translations: {},
            hash: null,
            next_question_hash_correct: null,
            next_question_hash_incorrect: null,
            next_question_hash_timeout: null,
            points_correct: null,
            points_incorrect: null,
            generated_question: true,
            verified: false,
          };

          $scope.actions.changeQuestionType(question);
          $scope.viewmodel.game.questions.push(question);
        }
      },
      toggleCaseModal(qIndex, aIndex, childAnswer) {
        // var answer_id = answer_id || null;
        const type = aIndex === 0 ? 'evidence' : 'suspect';
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-case.html',
            controller: 'CaseModalController',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              extras() {
                return {
                  closeButton: true,
                  childAnswer: angular.copy(childAnswer),
                  type,
                  evidence: angular.copy($scope.viewmodel.game.questions[qIndex].answers[0].answers),
                };
              },
            },
          })
          .result.then((newAnswer) => {
            $scope.gameForm.$setDirty();
            const qAnswerAnswers = $scope.viewmodel.game.questions[qIndex].answers[aIndex].answers;
            const index = qAnswerAnswers.indexOf(childAnswer);
            if (index === -1) {
              qAnswerAnswers.push(newAnswer);
            } else {
              qAnswerAnswers.splice(index, 1, newAnswer);
            }

            if (type === 'evidence') {
              const suspectAnswers = $scope.viewmodel.game.questions[qIndex].answers[1].answers;

              suspectAnswers.forEach((answer) => {
                if (index === -1) {
                  answer.evidence.push(newAnswer);
                } else {
                  newAnswer = angular.copy(newAnswer);
                  newAnswer.correct = answer.evidence[index].correct;
                  newAnswer.include = answer.evidence[index].include;
                  answer.evidence.splice(index, 1, newAnswer);
                }
              });
            }
          })
          .catch(angular.noop);
      },
      toggleCaseOptionsModal(qIndex, data) {
        // var answer_id = answer_id || null;
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-case-options.html',
            controller: 'CaseOptionsModalController',
            backdrop: true,
            size: 'lg',
            resolve: {
              extras() {
                return {
                  closeButton: true,
                  key: data.id,
                  data,
                  question: $scope.viewmodel.game.questions[qIndex],
                };
              },
            },
          })
          .result.then((properties) => {
            Object.assign($scope.viewmodel.game.questions[qIndex], properties);
          })
          .catch(angular.noop);
      },
      deleteCaseAnswerListItem(qIndex, aIndex, childAnswer) {
        modalService
          .showModal(
            {
              title: 'Delete List Item?',

              message:
                // eslint-disable-next-line max-len
                'Are you sure you want to delete this list item? All analytics data associated with the question will be permanently deleted.',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              const type = aIndex === 0 ? 'evidence' : 'suspect';
              const questionAnswer = $scope.viewmodel.game.questions[qIndex].answers[aIndex];
              questionAnswer.answers.splice(questionAnswer.answers.indexOf(childAnswer), 1);

              if (type === 'evidence') {
                $scope.viewmodel.game.questions[qIndex].answers[1].answers.forEach((suspect) => {
                  _.remove(suspect.evidence, { answer_id: childAnswer.answer_id });
                });
              }
            },
            () => {},
          );
      },
      addBranchOption(question) {
        question.hash = question.hash || uuidv4();
        let suffixString;
        if (question.question_type === 'interstitial') {
          suffixString = question.interstitial.name !== null ? `: ${question.interstitial.name}` : '';
        } else {
          suffixString = question.text !== null ? `: ${question.text}` : '';
        }

        const typeString = question.question_type === 'interstitial' ? 'Interstitial' : 'Question';
        const displayText = `${$scope.data.branchingOptions.length}. ${typeString}${suffixString}`;

        $scope.data.branchingOptions.push({
          displayText,
          hash: question.hash,
        });
      },
      updateBranchOptions(removedHash) {
        $scope.data.branchingOptions = [
          {
            displayText: 'Next Question',
            hash: null,
          },
        ];
        for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
          const question = $scope.viewmodel.game.questions[i];
          $scope.actions.addBranchOption(question);
        }

        $scope.data.branchingOptions.push({
          displayText: 'End Game',
          hash: '-1',
        });

        if (removedHash) {
          for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
            const question = $scope.viewmodel.game.questions[i];

            if (question.next_question_hash_correct === removedHash) {
              question.next_question_hash_correct = null;
            }

            if (question.next_question_hash_incorrect === removedHash) {
              question.next_question_hash_incorrect = null;
            }

            for (let j = 0; j < question.answers.length; j++) {
              if (question.answers[j].next_question_hash === removedHash) {
                question.answers[j].next_question_hash = null;
              }
            }
          }
        }
      },
      toggleCollapse(index) {
        if ($scope.data.isOpen[index]) {
          $scope.data.isOpen.length = 0;
          return;
        }
        $scope.data.isOpen.length = 0;
        $scope.data.isOpen[index] = true;
        if ($scope.viewmodel.game.questions[index]?.generated_question) {
          $scope.viewmodel.game.questions[index].verified = true;
        }
        $timeout(() => {
          $('html, body')
            .stop(true, false)
            .animate(
              {
                scrollTop: $('#parent-group').children('.panel').eq(index).offset().top - 120,
              },
              250,
            );
        }, 10);
      },
      moveQuestion(from, to) {
        $scope.gameForm.$setDirty();
        $scope.viewmodel.game.questions.splice(to, 0, $scope.viewmodel.game.questions.splice(from, 1)[0]);

        if ($scope.data.isOpen[from]) {
          $scope.data.isOpen.length = 0;
          $scope.data.isOpen[to] = true;
        } else if ($scope.data.isOpen[to]) {
          $scope.data.isOpen.length = 0;
          $scope.data.isOpen[from] = true;
        }

        $scope.actions.updateBranchOptions();
      },
      addAnswer(question) {
        $scope.gameForm.$setDirty();
        question.answers.push({
          answer_id: null,
          type: null,
          match_type: null,
          text: null,
          image: null,
          response: null,
          correct: false,
          translations: {},
          next_question_hash: null,
          points: null,
        });
      },
      toggleQuestionFeedbackCollapse(question, q_index, f_index) {
        // toggle accordion
        question.advanced_feedback[f_index].isOpen = !question.advanced_feedback[f_index].isOpen;

        // reset others
        for (let i = 0; i < question.advanced_feedback.length; i++) {
          if (i !== f_index) {
            question.advanced_feedback[i].isOpen = false;
          }
        }

        $timeout(() => {
          const el = angular
            .element('#parent-group')
            .children('.panel')
            .eq(q_index)
            .find('.category-group')
            .eq(f_index)
            .find('.panel');
          if (el.length) {
            $('html, body')
              .stop(true, false)
              .animate(
                {
                  scrollTop: el.offset().top - 120,
                },
                250,
              );
          }
        }, 10);
      },
      addAdvancedFeedback(question) {
        $scope.gameForm.$setDirty();
        // close other af accordions
        question.advanced_feedback.forEach((af) => {
          af.isOpen = false;
        });
        // create new one that is open by default
        question.advanced_feedback.push({
          advanced_feedback_id: null,
          layout: 'layout-left',
          text: null,
          image: null,
          audio: null,
          video: null,
          isOpen: true,
          translations: {},
        });
      },
      moveAdvancedFeedback(group, c_index, q_index, from, to) {
        $scope.gameForm.$setDirty();
        group.question_groups[c_index].questions[q_index].advanced_feedback.splice(
          to,
          0,
          group.question_groups[c_index].questions[q_index].advanced_feedback.splice(from, 1)[0],
        );
      },
      addGridRow(question) {
        $scope.gameForm.$setDirty();
        const row_num = question.answers.length;
        const newgridrow = [];
        for (let i = 0; i < question.answers[0].length; i++) {
          newgridrow.push({
            answer_id: null,
            type: null,
            text: null,
            image: null,
            response: null,
            correct: false,
            row: row_num,
            col: i,
            points: null,
          });
        }
        question.answers.push(newgridrow);

        question.row_titles.push({
          text: '',
          index: row_num,
        });
      },
      deleteGridRow(question, index) {
        $scope.gameForm.$setDirty();
        question.answers.splice(index, 1);
        question.row_titles.splice(index, 1);
      },
      deleteGridColumn(question, index) {
        $scope.gameForm.$setDirty();
        for (let i = 0; i < question.answers.length; i++) {
          question.answers[i].splice(index, 1);
        }
        question.column_titles.splice(index, 1);
      },
      addGridColumn(question) {
        $scope.gameForm.$setDirty();
        const row_num = question.answers.length;

        const colCount = question.answers[0].length;

        for (let i = 0; i < row_num; i++) {
          question.answers[i].push({
            answer_id: null,
            type: null,
            text: null,
            image: null,
            response: null,
            correct: false,
            row: row_num,
            col: colCount + 1,
            points: null,
          });
        }

        question.column_titles.push({
          text: '',
          index: question.column_titles.length + 1,
        });
      },
      answerTypeChanged(answer) {
        switch (answer.type) {
          case 'image':
            answer.text = null;
            break;
          case 'text':
            answer.image = null;
            break;
          case 'empty':
            answer.text = null;
            answer.image = null;
            break;
          default:
            break;
        }
      },
      deleteQuestion(question) {
        const questionHash = question.hash;

        if (question.question_id === null) {
          $scope.gameForm.$setDirty();
          $scope.viewmodel.game.questions.splice($scope.viewmodel.game.questions.indexOf(question), 1);
          $scope.actions.updateBranchOptions(questionHash);
          return;
        }

        modalService
          .showModal(
            {
              title: 'Delete Question?',
              message:
                // eslint-disable-next-line max-len
                'Are you sure you want to delete this question? All analytics data associated with the question will be permanently deleted.',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.gameForm.$setDirty();
              $scope.viewmodel.game.questions.splice($scope.viewmodel.game.questions.indexOf(question), 1);
              $scope.data.isOpen.length = 0;
              $scope.actions.updateBranchOptions(questionHash);
              $scope.actions.hasInterstitials();
            },
            () => {},
          );
      },
      selectAuthorizationType() {
        $scope.gameForm.$setDirty();
        switch ($scope.viewmodel.game.authorization_type) {
          case 0:
            $scope.viewmodel.game.user_lists = [];
            $scope.viewmodel.game.sso_provider_id = null;

            if (!$scope.viewmodel.game.registration.required) {
              $scope.viewmodel.game.slack_button = false;
            }
            break;
          case 1:
            $scope.viewmodel.game.sso_provider_id = null;
            break;
          case 2:
            $scope.viewmodel.game.user_lists = [];
            break;
          default:
            break;
        }
        if ($scope.viewmodel.game.session_limit > 0 && $scope.viewmodel.game.registration.required === false) {
          modalService
            .showModal(
              {
                title: 'Are you sure?',
                message: 'Turning off Single Sign on will turn off session limits.',
                actionButton: 'OK',
                closeButton: 'Cancel',
              },
              {
                backdrop: true,
                keyboard: true,
                animation: false,
              },
            )
            .then(() => {
              $scope.viewmodel.game.session_limit = 0;
            })
            .catch(() => {
              $scope.viewmodel.game.authorization_type = 2;
            });
        }
      },
      selectSsoProvider() {
        const sso_provider = $scope.data.ssoProviders.find(
          (provider) => provider.sso_provider_id === $scope.viewmodel.game.sso_provider_id,
        );

        if (sso_provider) {
          $scope.gameForm.$setDirty();
          $scope.viewmodel.game.sso_timeout = sso_provider.default_timeout;
        }
      },
      requireRegistration() {
        $scope.gameForm.$setDirty();

        if ($scope.viewmodel.game.registration.required === true) {
          $scope.viewmodel.game.registration.fields = angular.extend(
            {},
            $scope.data.registrationFields,
            _.keyBy($scope.viewmodel.game.registration.fields, 'key'),
          );
        } else {
          if ($scope.viewmodel.game.session_limit > 0 && $scope.viewmodel.game.authorization_type !== 2) {
            modalService
              .showModal(
                {
                  title: 'Are you sure?',
                  message: 'Turning off registration will turn off session limits.',
                  actionButton: 'OK',
                  closeButton: 'Cancel',
                },
                {
                  backdrop: true,
                  keyboard: true,
                  animation: false,
                },
              )
              .then(() => {
                $scope.viewmodel.game.session_limit = 0;
              })
              .catch(() => {
                $scope.viewmodel.game.registration.required = true;
              });
          }

          if (!$scope.viewmodel.game.authorization_type) {
            $scope.viewmodel.game.slack_button = false;
          }
        }
      },
      changeGameMode() {
        $scope.viewmodel.game.session_limit = 0;
      },
      toggleInitials(key) {
        $scope.gameForm.$setDirty();
        if (key === 'first_name') {
          $scope.viewmodel.game.registration.fields.first_name.label = 'First Name';
          $scope.viewmodel.game.registration.fields.first_name.key = key;
        } else {
          $scope.viewmodel.game.registration.fields.first_name.label = 'Initials';
          $scope.viewmodel.game.registration.fields.first_name.key = key;
        }
      },
      changeQuestionType(question) {
        const totalAnswers = question.answers.length;

        // Set min/max answers
        if (question.question_type === 'slider') {
          question.min_answers = 2;
          question.max_answers = 5;
        } else if (question.question_type === 'image') {
          question.min_answers = 2;
          question.max_answers = 4;
        } else if (question.question_type === 'text_input') {
          question.min_answers = 1;
          question.max_answers = 50;
          question.randomize_answers = false;
        } else if (question.question_type === 'grid') {
          question.min_answers = 1;
          question.max_answers = 6;
        } else if (question.question_type === 'scramble_letter' || question.question_type === 'scramble_sentence') {
          question.min_answers = 1;
          question.max_answers = 1;
        } else if (question.question_type === 'interstitial') {
          question.min_answers = 0;
          question.max_answers = 0;
          question.interstitial.text_color = question.interstitial.text_color || '#000000';
        } else if (question.question_type === 'poll') {
          question.min_answers = 2;
          question.max_answers = 5;

          if ($scope.isGameType(['scenarios'])) {
            question.max_answers = 6;
          }
        } else if ($scope.isGameType(['wof'])) {
          // This will only catch puzzle types since interstitial is higher up.
          question.min_answers = 2;
          question.max_answers = 2;
        } else {
          question.min_answers = 2;
          question.max_answers = 4;

          if ($scope.isGameType(['jump', 'match', 'trivia'])) {
            question.max_answers = 5;
          }
        }

        // WBS question overrides
        if ($scope.isGameType(['wbs'])) {
          if (question.question_type === 'image') {
            question.max_answers = 14;
          }
          if (question.question_type === 'multiple_choice') {
            question.min_answers = 1;
            question.max_answers = 1;
          }
          if (question.question_type === 'poll') {
            question.max_answers = 6;
          }
        }

        // Set image vs text
        if (question.question_type === 'image' && !$scope.isGameType(['wbs'])) {
          for (let i = 0; i < totalAnswers; i++) {
            question.answers[i].text = null;
          }
        } else if (!$scope.isGameType(['wbs'])) {
          for (let i = 0; i < totalAnswers; i++) {
            question.answers[i].image = null;
          }
        }

        // Set max correct
        if (question.question_type === 'multiple_select' || question.question_type === 'image') {
          question.max_correct = null;
        } else {
          question.max_correct = 1;

          const totalCorrect = $filter('filter')(
            question.answers,
            {
              correct: true,
            },
            true,
          ).length;

          if (totalCorrect > 1 || question.question_type === 'poll') {
            for (let i = 0; i < totalAnswers; i++) {
              question.answers[i].correct = false;
            }
          }
        }

        // if not poll unset show_results
        if (question.question_type !== 'poll') {
          question.show_results = null;

          if (question.question_type !== 'multiple_choice') {
            for (let i = 0; i < totalAnswers; i++) {
              question.answers[i].points = null;
            }
          }
        }

        // if poll or multiple choice points are set on the answers
        if (question.question_type === 'poll' || question.question_type === 'multiple_choice') {
          question.points_correct = null;
          question.points_incorrect = null;
        }

        if (question.answers.length > question.max_answers) {
          // Remove excess answers based on new max_answers
          question.answers.splice(question.max_answers, question.answers.length - question.max_answers);
        } else if (question.answers.length < question.min_answers) {
          // Add answers if below min_answers. Pre-calculate how many.
          const answersToAdd = question.min_answers - question.answers.length;
          for (let i = 0; i < answersToAdd; i++) {
            $scope.actions.addAnswer(question);
          }
        }

        // if it is not multiple choice we have to set the next_question_hash on the anwswers
        // to null because the next question id will come from the question
        if (question.question_type !== 'multiple_choice' && question.question_type !== 'poll') {
          for (let i = 0; i < question.answers.length; i++) {
            question.answers[i].next_question_hash = null;
          }
        }

        $scope.data.lastQuestionType = question.question_type;

        // Check for interstitials
        $scope.actions.hasInterstitials();
      },
      globalTimerCheck() {
        if ($scope.viewmodel.game.useGlobalTimer) {
          $scope.viewmodel.game.time_per_question = !$scope.viewmodel.game.time_per_question
            ? 60
            : $scope.viewmodel.game.time_per_question;
        } else {
          $scope.viewmodel.game.time_per_question = null;
        }
      },
      changeGameTimer() {
        if ($scope.viewmodel.game.useGameTimer) {
          $scope.viewmodel.game.game_timer = !$scope.viewmodel.game.game_timer ? 300 : $scope.viewmodel.game.game_timer;
        } else {
          $scope.viewmodel.game.game_timer = null;
        }
      },
      questionTimerCheck(question) {
        if (question.useTimer) {
          question.time = $scope.viewmodel.game.time_per_question;
        } else {
          question.time = null;
          question.next_question_hash_timeout = null;
          question.response_timeout = null;
        }
      },
      checkImage(image) {
        // $log.log(image)
        if (!image) {
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|svg/i;
        if (!allowed.test(ext)) {
          image.base64 = null;
          image = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 5MB.
        if (image.filesize > 5242880) {
          image.base64 = null;
          image = null;
          // image.invalid_size = true;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 5 MB in size.',
            'danger',
          );
          return;
        }

        $scope.gameForm.$setDirty();
      },
      checkAudio(audio) {
        // $log.log(audio)
        const allowed = /audio\/mpeg|audio\/mp3/.test(audio.file.type);

        if (!allowed) {
          audio = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        if (audio.file.size > 5242880) {
          audio = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Audio files cannot be more than 5 MB in size.',
            'danger',
          );
          return;
        }

        fileReader.readAsDataUrl(audio.file, $scope).then((result) => {
          audio.base64 = result;
          audio.filetype = audio.file.type;
          audio.filename = audio.file.name;
        });

        $scope.gameForm.$setDirty();
      },
      checkVideo(video) {
        // $log.log(video)
        const allowed = /video\/mp4/.test(video.file.type);

        if (!allowed) {
          video.file = null; // this is needed for some reason
          video = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        if (video.file.size > 104857600) {
          video.file = null; // this is needed for some reason
          video = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Video files cannot be more than 30 MB in size.',
            'danger',
          );
          return;
        }

        $scope.gameForm.$setDirty();
        video.url = URL.createObjectURL(video.file);

        // $log.log(video.url);
      },

      videoEmbed(video, translations) {
        if (translations === true) {
          video.image.original = '';
          video.image.resized = '';
          video.video.url = $scope.actions.processVideoUrl(video.video.url);
        } else {
          video.url = $scope.actions.processVideoUrl(video.url);
        }
        $scope.gameForm.$setDirty();
      },
      processVideoUrl(url) {
        if (url.includes('vimeo')) {
          const result = url.match(
            // eslint-disable-next-line max-len
            /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i,
          );
          return `https://player.vimeo.com/video/${result[1]}`;
        } else if (url.includes('youtu') && !url.includes('embed')) {
          const expr = /(youtu\.be\/|[?&]v=)([^&]+)/;
          return `https://www.youtube.com/embed/${url.match(expr)[2]}`;
        }
        return url;
      },
      updateTheme() {
        let theme = [];
        // Update Splash Screen based on theme
        if ($scope.viewmodel.game.assets.theme) {
          theme = $filter('filter')(
            $scope.data.themes,
            {
              key: $scope.viewmodel.game.assets.theme,
            },
            true,
          );
          if ($scope.viewmodel.game.assets.theme === 'custom') {
            if (!$scope.viewmodel.game.assets.theme_custom_color_1 && $scope.viewmodel.game.game_type === 'noodle') {
              $scope.viewmodel.game.assets.theme_custom_color_1 = '#FFFFFF';
              $scope.viewmodel.game.assets.theme_custom_color_2 = '#1298E1';
              $scope.viewmodel.game.assets.theme_custom_color_3 = '#C9C9C9';
              $scope.viewmodel.game.assets.theme_custom_color_4 = '#dce6ef';
              $scope.viewmodel.game.assets.theme_custom_color_5 = '#F0F0F0';
              $scope.viewmodel.game.assets.theme_custom_color_6 = null;
              $scope.viewmodel.game.assets.theme_custom_invert_text = false;
            }
          }

          if ($scope.viewmodel.game.splash.title.type === 'default' && theme.length) {
            $scope.viewmodel.game.splash.title.image = {
              url: theme[0].splash.title,
            };
          }

          if (!$scope.viewmodel.game.splash.background.type && theme.length) {
            $scope.viewmodel.game.splash.background.image = {
              url: theme[0].splash.background,
            };
          }
          if ($scope.isGameType(['detective'])) {
            if (angular.isDefined(theme[0].colors)) {
              if (theme[0].colors.primary !== null) {
                $scope.themeColorPrimary = {
                  'background-color': theme[0].colors.primary,
                };
              }
              if (theme[0].colors.secondary !== null) {
                $scope.themeColorSecondary = {
                  'background-color': theme[0].colors.secondary,
                };
              }
            }
          }
        }
        assetService.getTracks($scope.viewmodel.game.game_type).then((tracks) => {
          $scope.data.tracks = angular.copy(tracks);

          if (theme.length) {
            for (let i = 0; i < $scope.data.tracks; i++) {
              if ($scope.data.tracks[i].id === theme[0].track) {
                $scope.data.tracks[i].name += ' (default)';
              } else {
                $scope.data.tracks[i].name.replace(' (default)', '');
              }
            }
          }

          $scope.data.tracks.unshift({
            id: null,
            name: 'No Track',
            url: null,
          });
        });
      },
      toggleCustomThemeFont() {
        if ($scope.viewmodel.game.assets.theme_custom_invert_text) {
          $scope.viewmodel.game.assets.theme_custom_invert_text = true;
        } else {
          $scope.viewmodel.game.assets.theme_custom_invert_text = false;
        }
      },
      changeSplashLogo() {
        $scope.gameForm.$setDirty();
        $scope.viewmodel.game.splash.logo.image = null;
      },
      changeSplashTitle() {
        $scope.gameForm.$setDirty();

        if ($scope.viewmodel.game.splash.title.type === 'default' && $scope.viewmodel.game.assets.theme) {
          $scope.viewmodel.game.splash.title.image = {
            url: $filter('filter')(
              $scope.data.themes,
              {
                key: $scope.viewmodel.game.assets.theme,
              },
              true,
            )[0].splash.title,
          };
        } else {
          $scope.viewmodel.game.splash.title.image = null;
        }
      },
      changeSplashBackground() {
        $scope.gameForm.$setDirty();

        if ($scope.viewmodel.game.assets.theme && !$scope.viewmodel.game.splash.background.type) {
          $scope.viewmodel.game.splash.background.image = {
            url: $filter('filter')(
              $scope.data.themes,
              {
                key: $scope.viewmodel.game.assets.theme,
              },
              true,
            )[0].splash.background,
          };
        } else {
          $scope.viewmodel.game.splash.background.image = null;
        }
      },
      createAlert(msg, type, persistent) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });

        if ($scope.timer) {
          $timeout.cancel($scope.timer);
        }

        if (!persistent) {
          $scope.timer = $timeout(() => {
            $scope.data.alerts.splice($scope.data.alerts.length - 1, 1);
          }, 5000);
        }
      },
      makeSlug() {
        if (!$scope.viewmodel.game.slug) {
          $scope.viewmodel.game.slug = Slug.slugify($scope.viewmodel.game.name);
        }
      },
      fixSlug() {
        if ($scope.viewmodel.game.slug) {
          $scope.viewmodel.game.slug = Slug.slugify($scope.viewmodel.game.slug);
        }
      },
      tabChanged() {
        $window.scrollTo(0, 0);
        // need to broadcast a tab change for the various resize directives
        $rootScope.$broadcast('tabChanged');
      },
      copyUrl() {
        return gameService.getGameUrl($scope.viewmodel.game);
      },
      copySuccess(name) {
        if ($scope.copyTimer) {
          $timeout.cancel($scope.copyTimer);
        }

        $scope.data.copied = name;

        $scope.copyTimer = $timeout(() => {
          $scope.data.copied = false;
        }, 1500);
      },
      launch() {
        const url = gameService.getGameUrl($scope.viewmodel.game);

        $window.open(url, '_blank');
      },
      setLastGlobalTimePerQuestion() {
        $scope.viewmodel.game.lastTimePerQuestion = $scope.viewmodel.game.time_per_question;
      },
      changeGlobalTimePerQuestion() {
        // TODO: This whole system needs to be re-thought to make more sense to a user
        if ($scope.isGameType(['recall'])) {
          for (let i = 0; i < $scope.viewmodel.game.question_groups.length; i++) {
            if ($scope.viewmodel.game.question_groups[i].useTimer) {
              $scope.viewmodel.game.question_groups[i].time = $scope.viewmodel.game.time_per_question;
            }
          }
        } else if ($scope.isGameType(['jeopardy'])) {
          const lastGlobalTimeWasNull = $scope.viewmodel.game.lastTimePerQuestion === null;
          for (let i = 0; i < $scope.viewmodel.game.question_groups.length; i++) {
            const round = $scope.viewmodel.game.question_groups[i];
            for (let j = 0; j < round.question_groups.length; j++) {
              const category = round.question_groups[j];
              for (let k = 0; k < category.questions.length; k++) {
                // assuming that if they haven't changed the time value of a question from the default they want it updated
                const timeMatchesGlobalTime = category.questions[k].time === $scope.viewmodel.game.lastTimePerQuestion;
                // on new game creation the initial question time is null so need to account for this
                const nullInitUpdate = lastGlobalTimeWasNull && category.questions[k].time === null;
                if (timeMatchesGlobalTime) {
                  category.questions[k].time = $scope.viewmodel.game.time_per_question;
                }
                const useTimerSet = angular.isDefined(category.questions[k].useTimer);
                // on first load the value useTimer is undefined and must be set to save
                if (!useTimerSet || nullInitUpdate) {
                  // if the question has a deliberate time of 0 it means useTimer should be false
                  if (!category.questions[k].time) {
                    category.questions[k].useTimer = false;
                  } else {
                    // get the value of use timer from global game setting
                    category.questions[k].useTimer = $scope.viewmodel.game.useGlobalTimer;
                  }
                }
              }
            }
          }
        } else {
          for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
            if ($scope.viewmodel.game.questions[i].useTimer) {
              $scope.viewmodel.game.questions[i].time = $scope.viewmodel.game.time_per_question;
            }
          }
        }
        $scope.actions.setLastGlobalTimePerQuestion();
      },
      downloadScorm(version, lms) {
        let url = gameService.getScormUrl($scope.viewmodel.game.game_id, version);

        if ($scope.viewmodel.game.privacy) {
          url += `&token=${$scope.viewmodel.game.token}`;
        }

        if (lms) {
          url += `&lms=${lms}`;
        }

        $window.open(url);
      },
      addTranslation() {
        const { selectedTranslation } = $scope.data;
        $scope.data.activeTranslation = $scope.data.selectedTranslation;

        $scope.data.existingTranslations.push(selectedTranslation);
        $scope.data.existingTranslations = $filter('orderBy')($scope.data.existingTranslations, 'name', false);

        delete $scope.data.availableTranslations[selectedTranslation.language_id];

        $scope.data.selectedTranslation = null;
      },
      disableAITranslationButton() {
        const game = $scope.viewmodel.game;
        const total =
          (game.learn_more_button_text ? 1 : 0) +
          (game.popup?.body ? 1 : 0) +
          (game.popup?.title ? 1 : 0) +
          (game.splash?.logo?.text ? 1 : 0) +
          (game.splash?.title?.text ? 1 : 0) +
          game.questions.length +
          game.questions.reduce(
            (a, c) =>
              a +
              (c.question_type !== 'image' ? c.answers.length : 0) +
              c.advanced_feedback.length +
              (c.response_correct !== null && c.response_correct !== "" ? 1 : 0) +
              (c.response_incorrect !== null && c.response_incorrect !== "" ? 1 : 0) +
              (c.response_timeout !== null && c.response_timeout !== "" ? 1 : 0),
            0,
          );
        return total > 100;
      },
      generateAITranslation(languageId, keepCurrentTranslation = true) {
        const translation = $scope.data.allTranslations[languageId];
        const game = $scope.viewmodel.game;
        // If translation already exists for a field send null so AI doesn't translate it
        const data = {
          gameInfo: {
            learn_more_button_text: game.translations[languageId]?.learn_more_button_text && keepCurrentTranslation
              ? null
              : game.learn_more_button_text,
            popup_body: game.translations[languageId]?.popup?.body && keepCurrentTranslation ? null : game.popup.body,
            popup_title: game.translations[languageId]?.popup?.title && keepCurrentTranslation ? null : game.popup.title,
            splash_logo_text: game.translations[languageId]?.splash?.logo?.text && keepCurrentTranslation ? null : game.splash.logo.text,
            splash_title_text: game.translations[languageId]?.splash?.title?.text && keepCurrentTranslation ? null : game.splash.title.text,
          },
          questions: game.questions.map((q, q_index) => {
            return {
              question_text: q.translations[languageId]?.text && keepCurrentTranslation ? null : q.text,
              response_correct: q.translations[languageId]?.response_correct && keepCurrentTranslation ? null : q.response_correct,
              response_incorrect: q.translations[languageId]?.response_incorrect && keepCurrentTranslation ? null : q.response_incorrect,
              response_timeout: q.translations[languageId]?.response_timeout && keepCurrentTranslation ? null : q.response_timeout,
              advanced_feedback: game.questions[q_index].advanced_feedback.map((af) => {
                if (af.translations) {
                  return af.translations[languageId]?.text && keepCurrentTranslation ? null : af.text;
                } else {
                  return af.text;
                }
              }),
              question_answers: game.questions[q_index].answers.map((a) => {
                if (a.translations) {
                  return a.translations[languageId]?.text && keepCurrentTranslation ? null : a.text;
                } else {
                  return a.text;
                }
              }),
            };
          }),
        };

        $scope.loading = true;
        $scope.loadingAI = true;
        // [TTA-1809] Currently only way to tell if we need to show AI verification modal on save.
        // Should be updated that AI translations are tracked similar to questions
        $scope.generatedAITranslation = true;
        gameService
          .generateTranslation({
            code: translation.code,
            name: translation.name,
            data: data,
          })
          .then((response) => {
            $scope.loading = false;
            $scope.loadingAI = false;
            // Setting translations for Game Info
            // Use existing translation if possible, else create a new translation
            let current = game.translations[languageId]? game.translations[languageId] : {};
            if (response.gameInfo.learn_more_button_text)
              current.learn_more_button_text = response.gameInfo.learn_more_button_text;

            // Set popup
            if (!current.popup) current.popup = {};
            if (response.gameInfo.popup_body)   current.popup.body = response.gameInfo.popup_body;
            if (response.gameInfo.popup_title)  current.popup.title = response.gameInfo.popup_title;

            // Set splash
            if (!current.splash) current.splash = {};
            if (!current.splash.logo)   current.splash.logo = {};
            if (!current.splash.title)  current.splash.title = {};
            if (response.gameInfo.splash_logo_text)   current.splash.logo.text = response.gameInfo.splash_logo_text;
            if (response.gameInfo.splash_title_text)  current.splash.title.text = response.gameInfo.splash_title_text;

            game.translations[languageId] = current;


            // Setting translations for question text
            for (let i in game.questions) {
              let qTranslation = game.questions[i].translations[languageId];
              // Translation may not exist
              if (qTranslation) {
                if (response.questions[i].question_text) qTranslation.text = response.questions[i].question_text;
                if (response.questions[i].response_correct)
                  qTranslation.response_correct = response.questions[i].response_correct;
                if (response.questions[i].response_incorrect)
                  qTranslation.response_incorrect = response.questions[i].response_incorrect;
                if (response.questions[i].response_timeout)
                  qTranslation.response_timeout = response.questions[i].response_timeout;
              } else {
                game.questions[i].translations[languageId] = {
                  text: response.questions[i].question_text,
                  response_correct: response.questions[i].response_correct,
                  response_incorrect: response.questions[i].response_incorrect,
                  response_timeout: response.questions[i].response_timeout,
                };
              }

              // Setting translations for question answers
              for (let n in game.questions[i].answers) {
                if (!game.questions[i].answers[n].translations) game.questions[i].answers[n].translations = {};
                let aTranslation = game.questions[i].answers[n].translations[languageId];
                // Translation may not exist
                if (aTranslation) {
                  if (response.questions[i].question_answers[n])
                    aTranslation.text = response.questions[i].question_answers[n];
                } else {
                  game.questions[i].answers[n].translations[languageId] = {
                    text: response.questions[i].question_answers[n],
                  };
                }
              }

              // Setting translations for question advanced feedback
              for (let j in game.questions[i].advanced_feedback) {
                if (!game.questions[i].advanced_feedback[j].translations)
                  game.questions[i].advanced_feedback[j].translations = {};
                let afTranslation = game.questions[i].advanced_feedback[j].translations[languageId];
                // Translation may not exist
                if (afTranslation) {
                  if (response.questions[i].advanced_feedback[j])
                    afTranslation.text = response.questions[i].advanced_feedback[j];
                } else {
                  game.questions[i].advanced_feedback[j].translations[languageId] = {
                    text: response.questions[i].advanced_feedback[j],
                  };
                }
              }
            }

            // Need to save for new translation
            $scope.gameForm.$setDirty();
          })
          .catch((error) => {
            $scope.loading = false;
            console.log('Error', error);
          });
      },
      activateTranslation(translation) {
        $scope.data.activeTranslation = translation;
      },
      deleteTranslation(languageId) {
        const translation = $scope.data.allTranslations[languageId];
        $scope.data.availableTranslations[translation.language_id] = translation;

        for (let i = 0; i < $scope.data.existingTranslations.length; i++) {
          const e = $scope.data.existingTranslations[i];
          if (e.language_id === translation.language_id) {
            $scope.data.existingTranslations.splice(i, 1);
            break;
          }
        }

        delete $scope.viewmodel.game.translations[translation.language_id];

        // Delete question translations
        for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
          const question = $scope.viewmodel.game.questions[i];
          delete question.translations[translation.language_id];

          for (let j = 0; j < question.answers.length; j++) {
            const answer = question.answers[j];
            if (!$scope.isGameType(['grid'])) {
              delete answer.translations[translation.language_id];
            }
            if ($scope.isGameType(['grid'])) {
              for (let r = 0; r < answer.length; r++) {
                delete answer[r].translations[translation.language_id];
              }
            }
          }
        }

        // Delete question_group translations
        for (let g = 0; g < $scope.viewmodel.game.question_groups.length; g++) {
          const question_group = $scope.viewmodel.game.question_groups[g];
          delete question_group.translations[translation.language_id];

          for (let i = 0; i < question_group.questions.length; i++) {
            const question = question_group.questions[i];
            delete question.translations[translation.language_id];

            for (let j = 0; j < question.answers.length; j++) {
              const answer = question.answers[j];
              delete answer.translations[translation.language_id];
            }
          }

          // for jeopardy
          if (question_group.question_groups) {
            for (let q = 0; q < question_group.question_groups.length; q++) {
              const q_group = question_group.question_groups[q];
              delete q_group.translations[translation.language_id];
              for (let i = 0; i < q_group.questions.length; i++) {
                const question = q_group.questions[i];
                delete question.translations[translation.language_id];
                for (let j = 0; j < question.answers.length; j++) {
                  const answer = question.answers[j];
                  delete answer.translations[translation.language_id];
                }
              }
            }
          }
        }

        if ($scope.data.existingTranslations.length > 0) {
          [$scope.data.activeTranslation] = $scope.data.existingTranslations;
        } else {
          $scope.data.activeTranslation = null;
        }
      },
      changeDefaultLanguage(currentLanguageId) {
        const defaultLanguage = $scope.viewmodel.game.language_id;
        $scope.data.availableTranslations = angular.copy($scope.data.allTranslations);
        currentLanguageId = parseInt(currentLanguageId, 10);

        const translationExists = angular.isDefined(
          $scope.data.existingTranslations.find((id) => id.language_id === defaultLanguage),
        );
        // apply translation data to questions (apply new default language)
        if (translationExists) {
          const generateCurrLangTranslation = angular.isUndefined(
            $scope.data.existingTranslations.find((id) => id.language_id === currentLanguageId),
          );
          // add current (previous default) language data as a translation
          if (generateCurrLangTranslation) {
            $scope.data.selectedTranslation = $scope.data.allTranslations[currentLanguageId];
            $scope.actions.addTranslation();
          }
          // update translation data for the previous default language
          $scope.actions.updateGameCurrentTranslations(currentLanguageId);
          $scope.actions.updateQuestionCurrentTranslations(currentLanguageId);
          $scope.actions.updateQuestionGroupCurrentTranslations(currentLanguageId);

          // apply new default language translations to game fields where applicable
          $scope.actions.applyTranslationToGameData($scope.viewmodel.game.translations[defaultLanguage]);
          $scope.actions.applyTranslationToQuestion(defaultLanguage);
          $scope.actions.applyTranslationToQuestionGroup(defaultLanguage);

          $scope.data.activeTranslation = $scope.data.allTranslations[currentLanguageId];
          $scope.actions.deleteTranslation(defaultLanguage);
        }

        for (let i = 0; i < $scope.data.existingTranslations.length; i++) {
          delete $scope.data.availableTranslations[$scope.data.existingTranslations[i].language_id];
        }

        delete $scope.data.availableTranslations[$scope.viewmodel.game.language_id];
      },
      updateTranslationsForCurrentDefaultLang(translationDataType, translatableData, currentLanguageId) {
        let currentTranslations = {};
        for (const translationKey in $scope.data.translationKeys[translationDataType]) {
          currentTranslations[translationKey] = translatableData[translationKey];
        }
        translatableData.translations[currentLanguageId] = currentTranslations;
      },
      updateGameCurrentTranslations(currentLanguageId) {
        const game = $scope.viewmodel.game;
        const currentTranslations = {};
        currentTranslations.popup = {
          title: game.popup.title,
          body: game.popup.body,
        };
        currentTranslations.splash = {
          logo: {
            text: game.splash.logo.text,
            image: game.splash.logo.image,
            type: game.splash.logo.type,
          },
          title: {
            text: game.splash.title.text,
            image: game.splash.title.image,
            type: game.splash.title.type,
          },
        };
        currentTranslations.learn_more_button_text = game.learn_more_button_text;
        currentTranslations.meter_title_1 = game.meter_title_1;
        currentTranslations.meter_title_2 = game.meter_title_2;
        currentTranslations.info_1 = game.info_1;
        currentTranslations.info_2 = game.info_2;

        game.translations[currentLanguageId] = currentTranslations;
      },
      updateQuestionCurrentTranslations(currentLanguageId) {
        for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
          const question = $scope.viewmodel.game.questions[i];
          $scope.actions.updateTranslationsForCurrentDefaultLang('question', question, currentLanguageId);

          if ($scope.isGameType(['grid'])) {
            for (let r = 0; r < question.answers.length; r++) {
              const row = question.answers[r];
              for (let j = 0; j < row.length; j++) {
                const answer = row[j];
                $scope.actions.updateTranslationsForCurrentDefaultLang('answer', answer, currentLanguageId);
              }
            }
          } else {
            for (let j = 0; j < question.answers.length; j++) {
              const answer = question.answers[j];
              $scope.actions.updateTranslationsForCurrentDefaultLang('answer', answer, currentLanguageId);
            }
          }

          // advanced feedback slides
          for (let j = 0; j < question.advanced_feedback.length; j++) {
            const advanced_feedback = question.advanced_feedback[j];
            $scope.actions.updateTranslationsForCurrentDefaultLang(
              'advanced_feedback',
              advanced_feedback,
              currentLanguageId,
            );
          }
        }
      },
      updateQuestionGroupCurrentTranslations(currentLanguageId) {
        for (let g = 0; g < $scope.viewmodel.game.question_groups.length; g++) {
          const q_group = $scope.viewmodel.game.question_groups[g];
          // Jeopardy rounds (Jeopardy, Double Jeopardy, Final Jeopardy) are not translatable
          if (!$scope.isGameType(['jeopardy'])) {
            $scope.actions.updateTranslationsForCurrentDefaultLang('question_group', q_group, currentLanguageId);
          }
          for (let i = 0; i < q_group.questions.length; i++) {
            const question = q_group.questions[i];
            $scope.actions.updateTranslationsForCurrentDefaultLang('question', question, currentLanguageId);

            for (let j = 0; j < question.answers.length; j++) {
              const answer = question.answers[j];
              $scope.actions.updateTranslationsForCurrentDefaultLang('answer', answer, currentLanguageId);
            }
            // advanced feedback slides
            for (let j = 0; j < question.advanced_feedback.length; j++) {
              const advanced_feedback = question.advanced_feedback[j];
              $scope.actions.updateTranslationsForCurrentDefaultLang(
                'advanced_feedback',
                advanced_feedback,
                currentLanguageId,
              );
            }
          }

          if ($scope.isGameType(['jeopardy'])) {
            for (let q = 0; q < q_group.question_groups.length; q++) {
              const q_group_category = q_group.question_groups[q];
              q_group_category.text = q_group_category.name;
              $scope.actions.updateTranslationsForCurrentDefaultLang(
                'question_group',
                q_group_category,
                currentLanguageId,
              );
              for (let i = 0; i < q_group_category.questions.length; i++) {
                const question = q_group_category.questions[i];
                $scope.actions.updateTranslationsForCurrentDefaultLang('question', question, currentLanguageId);
                for (let j = 0; j < question.answers.length; j++) {
                  const answer = question.answers[j];
                  $scope.actions.updateTranslationsForCurrentDefaultLang('answer', answer, currentLanguageId);
                }
                // advanced feedback slides
                for (let j = 0; j < question.advanced_feedback.length; j++) {
                  const advanced_feedback = question.advanced_feedback[j];
                  $scope.actions.updateTranslationsForCurrentDefaultLang(
                    'advanced_feedback',
                    advanced_feedback,
                    currentLanguageId,
                  );
                }
              }
            }
          }
        }
      },
      applyNewDefaultLangTranslations(currentData, translatedData, translationDataType) {
        for (const translationKey in $scope.data.translationKeys[translationDataType]) {
          if (translatedData) {
            if (translatedData[translationKey] !== null) {
              currentData[translationKey] = translatedData[translationKey];
            }
          }
        }
        return currentData;
      },
      applyTranslationToGameData(translatedData) {
        if (translatedData) {
          const game = $scope.viewmodel.game;
          game.popup.title = translatedData.popup ? translatedData.popup.title : game.popup.title;
          game.popup.body = translatedData.popup ? translatedData.popup.body : game.popup.body;
          game.splash.logo.text = translatedData.splash.logo ? translatedData.splash.logo.text : game.splash.logo.text;
          game.splash.logo.image = translatedData.splash.logo
            ? translatedData.splash.logo.image
            : game.splash.logo.image;
          game.splash.title.text = translatedData.splash.title
            ? translatedData.splash.title.text
            : game.splash.title.text;
          game.splash.title.image = translatedData.splash.title
            ? translatedData.splash.title.image
            : game.splash.title.image;
          game.learn_more_button_text = translatedData.learn_more_button_text ?? game.learn_more_button_text;
          game.meter_title_1 = translatedData.meter_title_1 ?? game.meter_title_1;
          game.meter_title_2 = translatedData.meter_title_2 ?? game.meter_title_2;
          game.info_1 = translatedData.info_1 ?? game.info_1;
          game.info_2 = translatedData.info_2 ?? game.info_2;

          // set splash logo and title types
          // these aren't needed for translations, but they are needed for display purposes
          if (translatedData.splash.logo && translatedData.splash.logo.text) {
            game.splash.logo.type = 'text';
          }
          if (translatedData.splash.logo && translatedData.splash.logo.image.url) {
            game.splash.logo.type = 'image';
          }
          // jeopardy, wof, and 5s do not have a game title option in Game Info
          if (!$scope.isGameType('jeopardy') || !$scope.isGameType('wof') || !$scope.isGameType('5s')) {
            if (translatedData.splash.title && translatedData.splash.title.text) {
              game.splash.title.type = 'text';
            }
            if (translatedData.splash.image && translatedData.splash.image.url) {
              game.splash.title.type = 'image';
            }
          }
        }
      },
      applyTranslationToQuestion(defaultLanguage) {
        for (let i = 0; i < $scope.viewmodel.game.questions.length; i++) {
          let question = $scope.viewmodel.game.questions[i];
          question = $scope.actions.applyNewDefaultLangTranslations(
            question,
            question.translations[defaultLanguage],
            'question',
          );
          if ($scope.isGameType(['grid'])) {
            for (let r = 0; r < question.answers.length; r++) {
              const row = question.answers[r];
              for (let j = 0; j < row.length; j++) {
                let answer = row[j];
                answer = $scope.actions.applyNewDefaultLangTranslations(
                  answer,
                  answer.translations[defaultLanguage],
                  'answer',
                );
              }
            }
          } else {
            for (let j = 0; j < question.answers.length; j++) {
              let answer = question.answers[j];
              answer = $scope.actions.applyNewDefaultLangTranslations(
                answer,
                answer.translations[defaultLanguage],
                'answer',
              );
            }
          }
          // advanced feedback slides
          for (let j = 0; j < question.advanced_feedback.length; j++) {
            let advanced = question.advanced_feedback[j];
            advanced = $scope.actions.applyNewDefaultLangTranslations(
              advanced,
              advanced.translations[defaultLanguage],
              'advanced_feedback',
            );
          }
        }
      },
      applyTranslationToQuestionGroup(defaultLanguage) {
        for (let g = 0; g < $scope.viewmodel.game.question_groups.length; g++) {
          let q_group = $scope.viewmodel.game.question_groups[g];
          // Jeopardy rounds (Jeopardy, Double Jeopardy, Final Jeopardy) are not translatable
          if (!$scope.isGameType(['jeopardy'])) {
            q_group = $scope.actions.applyNewDefaultLangTranslations(
              q_group,
              q_group.translations[defaultLanguage],
              'question_group',
            );
          }
          for (let i = 0; i < q_group.questions.length; i++) {
            let question = q_group.questions[i];
            question = $scope.actions.applyNewDefaultLangTranslations(
              question,
              question.translations[defaultLanguage],
              'question',
            );
            for (let j = 0; j < question.answers.length; j++) {
              let answer = question.answers[j];
              answer = $scope.actions.applyNewDefaultLangTranslations(
                answer,
                answer.translations[defaultLanguage],
                'answer',
              );
            }
            // advanced feedback slides
            for (let j = 0; j < question.advanced_feedback.length; j++) {
              let advanced = question.advanced_feedback[j];
              advanced = $scope.actions.applyNewDefaultLangTranslations(
                advanced,
                advanced.translations[defaultLanguage],
                'advanced_feedback',
              );
            }
          }
          if ($scope.isGameType(['jeopardy'])) {
            for (let q = 0; q < q_group.question_groups.length; q++) {
              let q_group_category = q_group.question_groups[q];
              q_group_category = $scope.actions.applyNewDefaultLangTranslations(
                q_group_category,
                q_group_category.translations[defaultLanguage],
                'question_group',
              );
              q_group_category.name = q_group_category.translations[defaultLanguage]
                ? q_group_category.translations[defaultLanguage].text
                : q_group_category.text; // category name
              for (let i = 0; i < q_group_category.questions.length; i++) {
                let question = q_group_category.questions[i];
                question = $scope.actions.applyNewDefaultLangTranslations(
                  question,
                  question.translations[defaultLanguage],
                  'question',
                );
                for (let j = 0; j < question.answers.length; j++) {
                  let answer = question.answers[j];
                  answer = $scope.actions.applyNewDefaultLangTranslations(
                    answer,
                    answer.translations[defaultLanguage],
                    'answer',
                  );
                }
                // advanced feedback slides
                for (let j = 0; j < question.advanced_feedback.length; j++) {
                  let advanced = question.advanced_feedback[j];
                  advanced = $scope.actions.applyNewDefaultLangTranslations(
                    advanced,
                    advanced.translations[defaultLanguage],
                    'advanced_feedback',
                  );
                }
              }
            }
          }
        }
      },
      changeRegistrationFieldCondition(key) {
        // email or employee_id required
        if (key === 'employee_id' && $scope.viewmodel.game.registration.fields[key].condition !== 'required') {
          $scope.viewmodel.game.registration.fields.email.condition = 'required';
        }

        if (key === 'email' && $scope.viewmodel.game.registration.fields[key].condition !== 'required') {
          $scope.viewmodel.game.registration.fields.employee_id.condition = 'required';
        }
        if ($scope.viewmodel.game.registration.fields[key].condition === null) {
          if ($scope.data.registrationFieldArray.indexOf(key) > -1) {
            $scope.viewmodel.game.registration.fields[key].show_in_leaderboard = false;
            $scope.data.registrationFieldArray.splice($scope.data.registrationFieldArray.indexOf(key), 1);
          }
        }
      },
      changeCustomFieldCondition(field) {
        if (angular.isUndefined(field.condition)) {
          if ($scope.data.registrationFieldArray.indexOf(field.custom_field_id) > -1) {
            field.show_in_leaderboard = false;
            $scope.data.registrationFieldArray.splice(
              $scope.data.registrationFieldArray.indexOf(field.custom_field_id),
              1,
            );
          }
        }
        if (field.condition === 'disabled') {
          field.show_in_leaderboard = false;
          $scope.actions.checkLeaderboardFields();
        }
      },
      disableGenerationButton() {
        let data = $scope.viewmodel.aiGeneration;
        const total = data.multiple_choice + data.multiple_select + data.text_input + data.random;
        return (
          data.prompt_input === '' ||
          total > 20 ||
          total <= 0 ||
          ($scope.viewmodel.aiGeneration.totalQuestionsSelected >= total &&
            $scope.viewmodel.aiGeneration.generated_questions.length > 0)
        );
      },
      disableAddGenerationButton() {
        let data = $scope.viewmodel.aiGeneration;
        return !data.generated_questions.some((q) => q.selected);
      },
      generateQuestionModal() {
        $scope.showAIGeneration = !$scope.showAIGeneration;
        if ($scope.showAIGeneration) {
          $('html, body').stop(true, false).animate({ scrollTop: 0 }, 450);
        }
        $scope.viewmodel.aiGeneration = {
          generated_questions: [],
          prompt_input: '',
          multiple_choice: 0,
          multiple_select: 0,
          random: 0,
          text_input: 0,
          loading: false,
          totalQuestionsSelected: 0,
        };
      },
      checkTotalSelected() {
        let data = $scope.viewmodel.aiGeneration;
        data.totalQuestionsSelected = data.generated_questions.filter((q) => q.selected).length;
      },
      generate() {
        let data = $scope.viewmodel.aiGeneration,
          mc_total = 0,
          ms_total = 0,
          ti_total = 0,
          mc_extra = 0,
          ms_extra = 0,
          ti_extra = 0;

        if (data.generated_questions.length > 0) {
          data.generated_questions = data.generated_questions.filter(function (question) {
            if (!question.selected) {
              switch (question.question_type) {
                case 'multiple_choice':
                  mc_total += 1;
                  break;
                case 'multiple_select':
                  ms_total += 1;
                  break;
                case 'text_input':
                  ti_total += 1;
                  break;
              }
              return false;
            }
            return question.selected;
          });
        } else {
          mc_total = data.multiple_choice;
          ms_total = data.multiple_select;
          ti_total = data.text_input;

          // RANDOM QUESTIONS GENERATION
          for (let i = 0; i < data.random; i++) {
            let rand = Math.floor(Math.random() * 3);
            switch (rand) {
              case 0:
                mc_extra += 1;
                break;
              case 1:
                ms_extra += 1;
                break;
              case 2:
                ti_extra += 1;
                break;
            }
          }
        }

        $scope.loading = true;
        $scope.loadingAI = true;
        gameService
          .generateQuestions({
            topic: data.prompt_input,
            question_types: {
              multiple_choice: mc_total + mc_extra,
              multiple_select: ms_total + ms_extra,
              text_input: ti_total + ti_extra,
            },
          })
          .then((response) => {
            $scope.loading = false;
            $scope.loadingAI = false;
            data.generated_questions = data.generated_questions.concat(response);
          })
          .catch((error) => {
            $scope.loading = false;
            $scope.loadingAI = false;
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
              true,
            );
          });
      },
      addGeneratedQuestionsToGame() {
        $scope.viewmodel.aiGeneration.generated_questions = $scope.viewmodel.aiGeneration.generated_questions.filter(
          function (question) {
            return question.selected;
          },
        );
        $scope.actions.addGeneratedQuestions($scope.viewmodel.aiGeneration.generated_questions);
        $scope.viewmodel.aiGeneration = {
          generated_questions: [],
          prompt_input: '',
          multiple_choice: 0,
          multiple_select: 0,
          random: 0,
          text_input: 0,
          loading: false,
        };
        $scope.showAIGeneration = false;
      },
      presentTemplateModal() {
        const csvData = translationTemplateService.generateCSV($scope.viewmodel.game, $scope.data.allTranslations);
        const defaults = {
          backdrop: 'static',
          keyboard: false,
          animation: true,
          templateUrl: 'templates/partials/game/game_translation_modal.html',
          size: null,
        };

        const options = {
          title: 'Translation Template',
          closeButton: 'Cancel',
          actionButton: false,
          template: null,
          csv: csvData,
        };

        const actions = {
          downloadXLSX() {
            const workbook = translationTemplateService.generateXLSX(
              $scope.viewmodel.game,
              $scope.data.allTranslations,
            );
            workbook.xlsx
              .writeBuffer({ base64: true })
              .then((xls64) => {
                // build anchor tag and attach file (works in chrome)
                // eslint-disable-next-line angular/document-service
                const a = document.createElement('a');
                const data = new Blob([xls64], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const url = URL.createObjectURL(data);
                a.href = url;
                a.download = 'Translation Template.xlsx';
                // eslint-disable-next-line angular/document-service
                document.body.appendChild(a);
                a.click();
                // eslint-disable-next-line angular/timeout-service
                setTimeout(() => {
                  // eslint-disable-next-line angular/document-service
                  document.body.removeChild(a);
                  // eslint-disable-next-line angular/window-service
                  window.URL.revokeObjectURL(url);
                }, 0);
              })
              .catch((error) => {
                $log.log(error.message);
              });
          },
        };

        modalService.showModal(options, defaults, actions).then(
          (result) => {
            if (result.type === 'upload') {
              let showAlert = false;

              $scope.actions.submit(showAlert).then(() => {
                gameService.uploadTranslation($scope.viewmodel.game, result.files).then(
                  (game) => {
                    showAlert = true;
                    $timeout(() => {
                      $scope.actions.processGame(game, showAlert);
                    }, 2000);
                  },
                  (error) => {
                    $scope.actions.createAlert(
                      `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                      'danger',
                    );
                  },
                );
              });
            }
          },
          () => {},
        );
      },
      formatGridGame(game) {
        const { questions } = game;
        for (let i = 0; i < questions.length; i++) {
          if (questions[i].question_type === 'grid') {
            const question = questions[i];
            const { answers } = question;
            const formattedAnswers = [];
            let answerRow = [];
            for (let j = 0; j < answers.length; j++) {
              const answer = answers[j];
              answerRow.push(answer);
              if ((j + 1) % question.column_titles.length === 0) {
                formattedAnswers.push(answerRow);
                answerRow = [];
              }
            }
            question.answers = formattedAnswers;
          }
        }
        return game;
      },
      changeQuestionLimit() {
        if ($scope.data.hasQuestionLimit === false || $scope.viewmodel.game.randomize_questions === false) {
          $scope.viewmodel.game.question_limit = null;
        }
      },
      generateLTI() {
        const { game } = $scope.viewmodel;

        const data = {
          game_id: game.game_id,
          name: game.name,
          consumer_key: uuidv4(),
          secret: uuidv4(),
        };

        $scope.data.isGeneratingLTI = true;

        gameService.generateLTI(data).then((g) => {
          $scope.data.isGeneratingLTI = false;
          $scope.viewmodel.game = g;
        });
      },
      addCustomRegistrationField() {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-custom-field.html',
            controller: 'CustomFieldModalController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  closeButton: true,
                  game_id: $scope.data.game_id,
                };
              },
            },
          })
          .result.then((custom_field) => {
            custom_field.condition = 'required';
            $scope.viewmodel.game.registration.custom_fields.push(custom_field);
            $scope.gameForm.$setDirty();
          })
          .catch(angular.noop);
      },
      checkLeaderboardFields() {
        const registrationFieldKeys = Object.keys($scope.viewmodel.game.registration.fields);
        $scope.data.registrationFieldArray = [];

        registrationFieldKeys.forEach((key) => {
          // eslint-disable-next-line angular/definedundefined
          if (key !== 'undefined') {
            if ($scope.viewmodel.game.registration.fields[key].show_in_leaderboard) {
              $scope.data.registrationFieldArray.push(key);
            }
          }
        });

        $scope.viewmodel.game.registration.custom_fields.forEach((field) => {
          if (field.show_in_leaderboard) {
            $scope.data.registrationFieldArray.push(field.custom_field_id);
          }
        });
      },
      generateIframeCode(dimension) {
        const { embed } = $scope.viewmodel;
        const url = gameService.getGameUrl($scope.viewmodel.game);
        let src = null;

        // Calculate ratio by providing w or h and set the other to null.
        // If there's a w value, the h is calc'd regardless of whether it's passed in.
        // If there's no w, it is calculated based on h.
        const calcSixteenNine = function (w, h) {
          let value = 0;
          if (w) {
            value = Math.round((w * 9) / 16);
            return { w, h: value };
          }
          if (h && !w) {
            value = Math.round((h * 16) / 9);
            return { w: value, h };
          }
          return { w, h };
        };

        // If there's a ratio restriction... @TODO: can this be done more efficiently?
        if ($scope.data.gameTypeResolution === '16:9') {
          // Get the field that was just edited and update the other one.
          let calcedDimensions = 0;
          if (dimension === 'width') {
            calcedDimensions = calcSixteenNine(embed.width, 0);
            embed.height = calcedDimensions.h;
          } else if (dimension === 'height') {
            calcedDimensions = calcSixteenNine(0, embed.height);
            embed.width = calcedDimensions.w;
          }
        }

        if (embed.width && embed.height) {
          // eslint-disable-next-line max-len
          src = `<iframe src="${url}" style="overflow: hidden;" width="${embed.width}" height="${embed.height}" frameborder="0"></iframe>`;
        }

        return src;
      },
      tooltipPopup(title, text) {
        modalService
          .showModal(
            {
              title,
              message: text,
              actionButton: 'OK',
              closeButton: false,
            },
            {
              backdrop: true,
              keyboard: true,
            },
          )
          .catch(angular.noop);
      },
      importQuestionList() {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-question-lists.html',
            controller: 'QuestionListsModalController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  closeButton: true,
                  questionLists: $scope.data.questionLists,
                  question_list_id: $scope.viewmodel.game.question_list_id,
                  gameType: $scope.viewmodel.game.game_type,
                };
              },
            },
          })
          .result.then((question_list) => {
            $scope.viewmodel.game.questions = [];
            $scope.viewmodel.game.question_groups = [];

            question_list.questions.forEach((question) => {
              if (question.question_type === 'interstitial' && $scope.isGameType(['jump', 'match'])) {
                return;
              }

              $scope.viewmodel.game.questions.push(question);
            });

            if (question_list.question_groups.length) {
              const { question_groups } = question_list;

              for (let i = 0; i < question_groups.length; i++) {
                // Need the questions inside the question groups since the question groups don't exist yet
                question_groups[i].questions = question_list.questions.filter(
                  (question) =>
                    question.question_list_question_group_id === question_groups[i].question_list_question_group_id,
                );

                // Get 1 random question from each question group
                // @TODO: change this to a field entered in the question list selection modal
                if ($scope.isGameType(['flash'])) {
                  const random_question =
                    question_groups[i].questions[Math.floor(Math.random() * question_groups[i].questions.length)];

                  question_groups[i].questions = [random_question];
                }
              }

              $scope.viewmodel.game.question_groups = question_groups;
              $scope.viewmodel.game.questions = [];
            }

            $scope.viewmodel.game.language_id = question_list.language_id;
            $scope.viewmodel.game.available_translations = angular.copy(question_list.available_translations);
            $scope.viewmodel.game.question_list_id = question_list.question_list_id;
            $scope.viewmodel.game.question_list.name = question_list.name;

            // save game data when flash so the questions will appear on the cms
            if ($scope.isGameType(['flash'])) {
              $scope.actions.submit(true);
            } else {
              $scope.actions.processGame($scope.viewmodel.game);
            }
            // set form to dirty so user knows something was changed
            $scope.gameForm.$setDirty();
          })
          .catch(angular.noop);
      },
      checkDailyDoubleCategory(category, other_hash) {
        if (!other_hash) {
          // The _other_ daily double is random, so _this_ category is unrestricted.
          return true;
        }

        // Only if _this_ category contains the _other_ daily double is it restricted.
        return !category.questions.some((question) => question.hash === other_hash);
      },
      archiveGame() {
        if ($scope.data.gameId) {
          $scope.archiving = true;

          // If is_archived is set, then we are unarchiving, else we archive.
          const data = {
            game_id: $scope.data.gameId,
            is_archived: 1,
          };

          gameService.archiveGame(data).then(
            () => {
              flashService.set('<span class="fa fa-check"></span> Game archived successfully.', 'success');
              $scope.archiving = false;
              $state.go('v1.games');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
                true,
              );
              $scope.archiving = false;
            },
          );
        }
      },
      deleteGame() {
        if ($scope.data.gameId) {
          modalService
            .showModal(
              {
                title: 'Delete Game?',
                message:
                  // eslint-disable-next-line max-len
                  'Are you sure you want to delete this game? All data associated with the game will be deleted including questions, answers and analytics.',
                closeButton: 'No',
                actionButton: 'Yes',
              },
              {
                backdrop: true,
                keyboard: true,
                animation: false,
              },
            )
            .then(
              () => {
                $scope.deleting = true;

                const data = {
                  game_id: $scope.data.gameId,
                  is_deleted: 1,
                };
                gameService.deleteGame(data).then(
                  () => {
                    flashService.set('<span class="fa fa-check"></span> Game deleted successfully.', 'success');
                    $scope.deleting = false;
                    $state.go('v1.games');
                  },
                  (error) => {
                    $scope.actions.createAlert(
                      `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                      'danger',
                      true,
                    );
                    $scope.deleting = false;
                  },
                );
              },
              () => {},
            );
        }
      },
      setDefaultHex() {
        if ($scope.data.gameId) {
          modalService
            .showModal(
              {
                title: 'Reset Colors?',
                message: 'Are you sure you want to reset selected custom colors to default?',
                closeButton: 'No',
                actionButton: 'Yes',
              },
              {
                backdrop: true,
                keyboard: true,
                animation: false,
              },
            )
            .then(() => {
              $scope.gameForm.$setDirty();
              $scope.viewmodel.game.assets.theme_custom_color_1 = '#FFFFFF';
              $scope.viewmodel.game.assets.theme_custom_color_2 = '#1298E1';
              $scope.viewmodel.game.assets.theme_custom_color_3 = '#C9C9C9';
              $scope.viewmodel.game.assets.theme_custom_color_4 = '#dce6ef';
              $scope.viewmodel.game.assets.theme_custom_color_5 = '#F0F0F0';
              $scope.viewmodel.game.assets.theme_custom_color_6 = null;
            });
        }
      },
      forceHex(model, prop) {
        if (!model[prop]) {
          return;
        }

        if (model[prop][0] !== '#') {
          model[prop] = `#${model[prop]}`;
        }

        if (model[prop].length !== 7) {
          model[prop] = null;
        }
      },
      clearHex(model, prop) {
        model[prop] = null;
      },
      addTag(tag) {
        $scope.data.tags.push(tag);
        $scope.data.tags = _.uniq($scope.data.tags).sort();
      },
      publishToDocebo() {
        $scope.doceboUploadProcessing = true;
        const { game_id } = $scope.viewmodel.game;
        const { domain } = domainService;
        gameService
          .publishToDocebo({
            game_id,
            domain,
          })
          .then(() => {
            $scope.actions.createAlert(
              '<span class="fa fa-check"></span> Published to Docebo successfully.',
              'success',
            );
          })
          .catch((error) => {
            if (error.message) {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
            } else {
              $scope.actions.createAlert(
                '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> There was an error processing your request.',
                'danger',
              );
            }
          })
          .finally(() => {
            $scope.doceboUploadProcessing = false;
          });
      },
      toggleDemoModal() {
        modalService
          .showModal(
            {
              title: 'Demo Game Setting Activated',
              message:
                // eslint-disable-next-line max-len
                'This game is currently in demo mode and can only be modified by Super Admins. Other users do not have the ability to edit this game.',
              closeButton: 'Cancel',
              actionButton: 'Save',
              actionClass: 'primary',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              if (
                $scope.viewmodel.game.questions.some((question) => question.generated_question && !question.verified)
              ) {
                $scope.actions.toggleAIConfirmModal();
              } else {
                $scope.actions.submit(true);
              }
            },
            () => {},
          );
      },
      toggleAIConfirmModal() {
        modalService
          .showModal(
            {
              title: $translate.instant('common.notice').toString(),
              message: $translate.instant('game.ai.ai_verify_message').toString(),
              closeButton: 'Cancel',
              actionButton: 'Save',
              actionClass: 'primary',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.viewmodel.game.questions.forEach((question) => {
                if (question.generated_question) {
                  question.verified = true;
                }
              });
              $scope.generatedAITranslation = false;
              $scope.actions.submit(true);
            },
            () => {},
          );
      },
      toggleAITranslateConfirmModal(languageId) {
        modalService
          .showModal(
            {
              title: $translate.instant('common.notice').toString(),
              message: $translate.instant('game.ai.translate_verify_modal').toString(),
              closeButton: 'Cancel',
              actionButton: 'Agree',
              actionClass: 'primary',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              if ($scope.data.existingTranslations.find((id) => id.language_id === languageId)) {
                $scope.actions.toggleOverwriteTranslationModal(languageId);
              } else {
                $scope.actions.generateAITranslation(languageId);
              }
            },
            () => {},
          );
      },
      toggleOverwriteTranslationModal(languageId) {
        $uibModal
          .open({
            animation: false,
            controller: 'OverwriteTranslationController',
            templateUrl: 'templates/partials/modal-translation-overwrite.html',
            backdrop: true,
            keyboard: true,
          })
          .result.then((overwriteTranslation) => {
            $scope.actions.generateAITranslation(languageId, overwriteTranslation);
          })
          .catch(angular.noop);
      },
      checkGameName() {
        if (!$scope.viewmodel.game.name) {
          $scope.gameName = null;
          return;
        }

        $scope.checkingGameName = true;

        gameService.checkGameName({
          name: $scope.viewmodel.game.name,
          domain: $scope.data.domain,
          game_id: $scope.data.gameId})
          .then((gameName) => {
            $scope.gameName = gameName;

            if (gameName.available === false && !$scope.data.gameId) {
              $scope.gameForm.name.$setValidity('required', false);

              if ($scope.gameForm.name) {
                $scope.gameForm.name.$setValidity('required', false);
              }
            }

            $scope.checkingGameName = false;
          },
          (err) => {
            $scope.gameName = {
              available: false,
            };

            if (err.message) {
              $scope.gameName.message = err.message;
            }

            $scope.gameForm.name.$setValidity('required', false);

            if ($scope.gameForm.name) {
              $scope.gameForm.name.$setValidity('required', false);
            }

            $scope.checkingGameName = false;
          },
        );
      },
    };

    $scope.isGameType = (types = []) => {
      // put value into Array if array isn't passed
      const toCheck = !angular.isArray(types) ? [types] : types;
      return toCheck.includes($scope.viewmodel.game.game_type);
    };

    $scope.checkThemeOrientation = (theme) => {
      if (theme && $scope.data.themes && $scope.data.themes.length) {
        const i = $scope.data.themes.findIndex((t) => t.key === theme);
        if (i > -1) {
          return $scope.data.themes[i].orientation;
        }
      }
      return '';
    };

    // disable the consent toggle if privacy name and URL are erased
    // and return whether the toggle should be enabled
    $scope.checkConsentToggleEnabled = () => {
      const { privacy_policy_name, privacy_policy_url, privacy_policy_required } = $scope.viewmodel.game;
      const noNameNoURL =
        (angular.isUndefined(privacy_policy_name) || privacy_policy_name === '' || privacy_policy_name === null) &&
        (angular.isUndefined(privacy_policy_url) || privacy_policy_url === '' || privacy_policy_url === null);
      if (noNameNoURL && privacy_policy_required) {
        $scope.viewmodel.game.privacy_policy_required = false;
      }
      return noNameNoURL;
    };

    // Warn before browser unloading when the form is dirty.
    function beforeUnloadHandler(e) {
      if (!$scope.gameForm.$dirty) {
        return;
      }
      e.preventDefault();
      e.returnValue = '';
    }
    $window.addEventListener('beforeunload', beforeUnloadHandler);

    $scope.$on('$stateChangeStart', (event, nextState, nextParams) => {
      // Warn before router state change when the gameForm is dirty.
      if (!$scope.gameForm.$dirty) {
        return;
      }
      event.preventDefault();
      modalService
        .showModal(
          {
            title: $translate.instant('game.unsaved.title').toString(),
            message: $translate.instant('game.unsaved.message').toString(),
            closeButton: $translate.instant('common.cancel').toString(),
            actionButton: $translate.instant('common.yes').toString(),
            actionClass: 'danger',
          },
          {
            backdrop: true,
            keyboard: true,
            animation: false,
          },
        )
        .then(() => {
          $scope.gameForm.$setPristine();
          $state.go(nextState, nextParams);
        })
        .catch((err) => {
          if (err !== 'cancel') {
            throw err;
          }
        });
    });

    $scope.$on('$destroy', () => {
      rootScopeCacheService.set('GameControllerScope', null);
      $window.removeEventListener('beforeunload', beforeUnloadHandler);
    });

    $scope.initialize();
  },
]);
